export default {
    route: {
        dashboard: 'Panel de control',
        article: 'Artículos',
    },
    month: {
        jan: 'Enero',
        feb: 'Febrero',
        mar: 'Marzo',
        apr: 'Abril',
        may: 'Mayo',
        jun: 'Junio',
        jul: 'Julio',
        aug: 'Agosto',
        sep: 'Septiembre',
        oct: 'Octubre',
        nov: 'Noviembre',
        dec: 'Diciembre',
    },
    week: {
        mon: 'lu',
        tue: 'ma',
        wed: 'mi',
        thu: 'ju',
        fri: 'vi',
        sat: 'sá',
        sun: 'do',
    },
    navbar: {
        logOut: 'Cerrar sesión',
        myProfile: 'Mi perfil',
        termsConditions: 'Términos y condiciones',
    },
    login: {
        title: 'Iniciar sesión: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        logIn: 'Iniciar sesión',
        username: 'Nombre de usuario',
        password: 'Contraseña',
        loginForm: {
            header: 'Bienvenido/a a ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Introduzca el código de su autenticador.',
            subheader: 'Introduzca el código de 6 dígitos a continuación para continuar',
            placeholderSecurityCode: 'Introduzca aquí el código de seguridad',
        },
        forgotPassword: {
            header: '¿Ha olvidado la contraseña?',
            subheader:
                'Introduzca a continuación su correo electrónico y le enviramos un mensaje para restablecer la contraseña',
            placeholderEmail: 'Introduzca su correo electrónico',
        },
        resetPassord: {
            header: 'Restablezca la contraseña.',
            subheader: 'Introduzca el código que le hemos enviado por correo electrónico y restablezca la contraseña.',
            placeholder: {
                code: 'Introduzca el código',
                newPassWord: 'Introduzca la contraseña nueva',
                confirmPassWord: 'Vuelva a confirmar la contraseña',
            },
            success: 'Su contraseña se ha restablecido satisfactoriamente.',
        },
        button: {
            login: 'Iniciar sesión',
            forgotPassword: '¿Ha olvidado la contraseña?',
            resetMyPassword: 'Restablecer mi contraseña',
            submitMyPassword: 'Guardar contraseña nueva',
            back: 'Atrás',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: 'Recordarme',
            password: 'Contraseña',
            userId: 'ID de usuario',
            copyright: 'Derechos de autor ##COMPANY_BRAND_NAME##.',
            showPassword: 'Mostrar contraseña',
            hidePassword: 'Ocultar contraseña',
        },
        errors: {
            email: {
                email: 'Introduzca una dirección de correo electrónico válida.',
                required: 'Introduzca su correo electrónico.',
            },
            password: {
                required: 'Introduzca su contraseña.',
                max: 'La contraseña debe tener al menos 8 caracteres',
            },
            securityCode: {
                required: 'Introduzca el código de seguridad.',
                max: 'El código de seguridad debe tener al menos 6 caracteres',
            },
            verificationCodeInvalid: 'Código de verificación no válido.',
            generalError: 'Error al procesar su solicitud.',
            incorrectCredentials: 'Nombre de usuario o contraseña incorrectos.',
            defaultPasswordExpired: 'Su contraseña ha expirado y debe restablecerla un administrador.',
            inValidEmailAddress: 'La dirección de correo electrónico no es válida.',
            securityCodeInvalid: 'Código de seguridad no válido.',
            verificationCodeFormat: 'Introduzca el código de verificación de 6 dígitos.',
            passwordFormat:
                'La contraseña debe incluir al menos 15 caracteres, y al menos una mayúscula, una minúscula, un carácter especial y un número.',
            confirmPasswordMatch: 'La contraseña y la confirmación de contraseña no coinciden.',
            common: 'Algo ha fallado, vuelva a intentarlo.',
        },
        toast: {
            error: 'Algo ha fallado, vuelva a intentarlo.',
        },
    },
    dashboard: {
        title: 'Inicio: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Panel de control',
        formtitle: 'Validación de formulario',
        label: {
            pending: 'Pendiente',
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito disponible',
            unbilledAmount: 'Importe no facturado',
            filter: 'Filtro',
            reportTags: 'Etiquetas informe',
            driverGroup: 'Grupos de conductor',
            selectDriverGroup: 'Seleccionar grupos de conductor',
            selectTags: 'Seleccionar etiquetas',
            dateRange: 'Rango de fechas',
            month: 'Mes',
            year: 'Año',
            day: 'Día',
            week: 'Semana',
            userSessionTitle: 'Sesiones del conductor',
            userSessions: 'Sesiones del conductor',
            expenseTitle: 'Total del gasto',
            expense: 'Gasto',
            energyTitle: 'Total de energía (kWh)',
            enrgy: 'Energía',
            averageTransationTitle: 'Promedio de transacciones',
            transaction: 'Transacción',
            creditLimit: 'Límite de crédito',
            totalDriverAccounts: 'Total de cuentas de conductor',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Borrar',
        },
        cpoType: {
            Both: 'Ambos',
            Local: 'Local',
            International: 'Internacional',
        },
    },
    permission: {
        createArticle: 'Añadir artículo',
        editArticle: 'Editar artículo',
        save: 'Guardar',
        confirm: '¿Está seguro/a?',
        cancel: 'Cancelar',
        update: 'Actualizar',
    },
    table: {
        pagination: {
            prev: 'Anterior',
            nrev: 'Siguiente',
            showing: 'Mostrando',
        },
        data: {
            noData: 'No se han encontrado datos.',
        },
    },
    article: {
        title: 'Administrar artículo',
        id: 'ID de artículo',
        date: 'Fecha',
        tabletitle: 'Título',
        author: 'Autor',
        reviewer: 'Autor de la reseña',
        actions: 'Acciones',
        saveMessage: 'Artículo guardado satisfactoriamente',
        updateMessage: 'Artículo actualizado satisfactoriamente',
        deleteMessage: 'Artículo eliminado satisfactoriamente',
    },
    user: {
        title: 'Usuarios: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        user: 'Usuarios',
        manageUser: 'Administrar usuario',
        placeholder: {
            name: 'Nombre',
            email: 'Dirección de correo electrónico',
            phoneNo: 'N.º de teléfono',
            firstName: 'Nombre',
            lastName: 'Apellidos',
            userGroup: 'Grupos de usuario',
            userRoles: 'Perfiles de usuario',
            Organisation: 'Organización',
            select: 'Seleccionar estado',
            selectOrganisation: 'Seleccionar organización',
            selectUserGroup: 'Seleccionar grupo de usuario',
            languagePreference: 'Preferencia de idioma',
        },
        label: {
            firstName: 'Nombre',
            lastName: 'Apellidos',
            email: 'Correo electrónico',
            phoneNo: 'N.º de teléfono',
            optional: '(Opcional)',
            userGroups: 'Grupos de usuario',
            userRoles: 'Perfiles de usuario',
            Organisation: 'Organización',
            createdDate: 'Fecha creada',
            id: 'ID',
            action: 'Acción',
            status: 'Estado',
            name: 'Nombre',
            delete: 'Eliminar',
            enable: 'Permitir',
            all: 'Todos',
            disable: 'Deshabilitar',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            pending: 'Pendiente',
            reset2FA: 'Restablecer 2FA',
            deleted: 'Eliminado',
            lastLoginDate: 'Fecha de último inicio de sesión',
            languagePreference: 'Preferencia de idioma',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Añadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            sendEmail: 'Enviar correo electrónico',
            reset2FA: 'Restablecer 2FA',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            sendMailConfirmMessage: '¿Está seguro/a de que desea enviar el correo electrónico?',
            mailSentSuccessMessage: 'Correo electrónico enviado satisfactoriamente.',
            reset2FAConfirmMesage: '¿Está seguro/a de que desea restablecer el 2FA para este usuario?',
        },
        errors: {
            email: {
                required: 'Introduzca la dirección de correo electrónico',
                email: 'Introduzca una dirección de correo electrónico válida',
            },
            firstName: {
                required: 'Introduzca el nombre',
                valid: 'Introduzca un nombre válido',
            },
            lastName: {
                required: 'Introduzca el apellido',
                valid: 'Introduzca un apellido válido',
            },
            phoneNo: {
                required: 'Introduzca un número de teléfono',
                match: 'Introduzca un número de teléfono válido',
            },
            userGroups: {
                required: 'Seleccione al menos un grupo de usuario',
            },
            organization: {
                required: 'Seleccione una organización',
            },
        },
    },
    userGroup: {
        title: 'Grupos de usuario: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        manageUserGroup: 'Administrar grupo de usuario',
        users: 'Usuarios',
        header: 'Grupos de usuario',
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            edit: 'Editar',
            delete: 'Eliminar',
            save: 'Guardar',
            cancel: 'Cancelar',
            yes: 'Sí',
            no: 'No',
            action: 'Acción',
            add: 'Añadir',
            back: 'Atrás',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            permission: 'Permiso de acceso',
        },
        placeholder: {
            groupName: 'Nombre del grupo',
            users: 'Seleccionar usuarios',
            select: 'Seleccionar estado',
            organisation: 'Seleccionar organización',
        },
        message: {
            deleteConfirmMesageForOrganistion:
                'Al eliminar este grupo de organización, eliminaremos la asociación de grupo para una organización concreta, ¿está seguro/a de que desea continuar?',
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
        },
        label: {
            id: 'ID',
            name: 'Nombre',
            description: 'Descripción',
            Organisation: 'Organización',
            createdBy: 'Creado por',
            status: 'Estado',
            modifiedBy: 'Modificado por',
            createdDate: 'Fecha de creación',
            modifiedDate: 'Fecha de modificación',
            action: 'Acción',
            groupName: 'Nombre del grupo',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            phoneNo: 'Número de teléfono',
            email: 'Dirección de correo electrónico',
            groupAccess: 'Acceso de grupo',
            selectUsers: 'Seleccionar usuarios',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            yes: 'Sí',
            no: 'No',
        },
        form: {
            groupName: {
                label: 'Nombre del grupo',
                placeholder: 'Introduzca el nombre del grupo',
            },
            description: {
                label: 'Descripción',
                placeholder: 'Introduzca la descripción',
            },
            Organisation: {
                label: 'Organización',
            },
        },
        errors: {
            groupName: {
                required: 'Introduzca el nombre del grupo',
                valid: 'Introduzca un nombre de grupo válido',
                max: 'Se permite un máximo de 50 caracteres',
            },
            description: {
                max: 'Se permite un máximo de 255 caracteres',
            },
            userList: {
                required: 'Seleccione al menos un usuario',
            },
        },
        permission: {
            header: 'Permiso',
            label: {
                module: 'Módulo',
                subModule: 'Submódulo',
                action: 'Acción',
            },
        },
    },
    transactions: {
        headerTitle: 'Transacciones del conductor - ##COMPANY_BRAND_NAME## : Carga rápida de VE Reino Unido',
        title: 'Transacciones de conductor',
        transaction: 'Transacción',
        columns: {
            amount: 'Cantidad',
            location: 'Ubicación',
            date: 'Fecha',
            milesAdded: 'Millas añadidas',
            time: 'Tiempo',
            cost: 'Coste',
            energy: 'Energía',
            action: 'Acción',
            remark: 'Observaciones',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Cerrando',
            transaction: 'ID de transacción',
            name: 'Nombre',
            type: 'Tipo',
            federatedAccount: 'Tipo de cuenta federada',
            reference_id: 'ID de  referencia',
        },
        form: {
            charge: 'Cargando',
            payment: 'Pago',
            month: 'Mes',
        },
        label: {
            exportAll: 'Exportar todo',
            driver: 'Conductor',
            vehicle: 'Vehículo',
            cardPayment: 'Pago con tarjeta',
            referralBonus: 'Bono de recomendación',
            rewards: 'Recompensas',
            transactionDetails: 'Detalles de la transacción',
            transaction_id: 'ID de transacción',
            fullName: 'Nombre completo',
            email: 'Correo electrónico',
            phone_number: 'Número de teléfono',
            viewFailedPayments: 'Ver pagos fallidos',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Atrás',
        },
        placeholder: {
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de fin',
            name: 'Nombre',
            chargingStation: 'Estación de carga',
            selectType: 'Seleccionar tipo',
            transaction: 'ID de transacción',
            reference_id: 'ID de  referencia',
        },
        message: {
            noDataToExport: 'No hay datos que exportar.',
            error: {
                common: 'Algo ha fallado. Vuelva a intentarlo',
            },
        },
    },
    driver: {
        title: 'Conductores: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Conductores',
        manageDriver: 'Administrar conductor',
        startCharge: 'Iniciar carga remota',
        activities: 'Actividades',
        detail: 'Datos del conductor',
        address_detail: 'Dirección',
        billing_address_detail: 'Dirección de facturación',
        chargeDetails: 'Detalles de carga',
        debtLetterHistory: 'Historial de cartas de deuda',
        note: 'Nota: Si la recompensa existente del conductor es diferente a la nueva promoción, los Volts actuales desaparecerán.',
        charityAdded: 'Donación benéfica añadida',
        cd: 'cd',
        placeholder: {
            name: 'Nombre',
            email: 'Dirección de correo electrónico',
            firstName: 'Nombre',
            lastName: 'Apellidos',
            payment_card: 'Últimos 4 dígitos de la tarjeta de pago',
            select: {
                status: 'Seleccionar estado',
                account_type: 'Seleccionar tipo de cuenta',
                payment_type: 'Seleccionar tipo de pago',
                driver_groups: 'Seleccionar grupos de conductor',
                driver_tags: 'Seleccionar etiquetas',
                organization: 'Seleccionar organización',
                promotion: 'Seleccionar promoción',
            },
            driverGroup: 'Grupos de conductor',
            organization: 'Organización',
            account_type: 'Tipo de cuenta',
            payment_type: 'Tipo de pago',
            referral_code: 'Código de recomendación',
            driver_tags: 'Etiquetas',
            address: 'Línea de dirección 1',
            address2: 'Línea de dirección 2',
            city: 'Ciudad',
            county: 'Condado',
            postal_code: 'Código postal',
            billing_address: 'Línea de dirección 1',
            billing_address2: 'Línea de dirección 2',
            billing_city: 'Ciudad',
            billing_county: 'Condado',
            billing_postal_code: 'Código postal',
            promotion: 'Promociones',
            currentDriverPromotion: 'Promoción actual',
            driverPromotionJoinDate: 'Fecha en la que se unió',
            chargeLocation: 'Ubicación',
            chargeStation: 'Estación',
            connector: 'Conector',
            limitedKWH: 'kWh limitados:',
            confirmationNote:
                'Para que la cuenta sea segura, confirme el nombre, el apellido, la línea de dirección 1 y el código postal del conductor individual antes de iniciar la carga remota. Marque la casilla después de la confirmación del cliente',
            rfidCard: 'Tarjeta RFID',
            confirmationNoteFleet: 'Confirme esta contraseña con el conductor:',
            vehicle_number: 'Número de vehículo',
            api_url: 'URL de la API',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de fin',
            publicRFID: 'ID de tarjeta de RFID',
            languagePreference: 'Preferencia de idioma',
            searchAddress: 'Dirección',
        },
        label: {
            firstName: 'Nombre',
            lastName: 'Apellidos',
            email: 'Correo electrónico',
            group: 'Grupo',
            driverGroups: 'Grupos de conductor',
            driver_tags: 'Etiquetas',
            organization: 'Organización',
            payment_type: 'Tipo de pago',
            referral_code: 'Código de recomendación',
            createdDate: 'Fecha de creación',
            id: 'ID',
            action: 'Acción',
            status: 'Estado',
            account_type: 'Tipo de cuenta',
            type: 'Tipo',
            name: 'Nombre',
            delete: 'Eliminar',
            enable: 'Permitir',
            all: 'Todos',
            disable: 'Deshabilitar',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            cancelled: 'Cancelado',
            deleted: 'Eliminado',
            address: 'Dirección',
            address2: 'Línea de dirección 2',
            city: 'Ciudad',
            county: 'Condado',
            postal_code: 'Código postal',
            billing_address: 'Línea de dirección 1',
            billing_address2: 'Línea de dirección 2',
            billing_city: 'Ciudad',
            billing_county: 'Condado',
            billing_postal_code: 'Código postal',
            promotion: 'Promociones',
            expired: '- Caducada',
            currentDriverPromotion: 'Promoción actual',
            driverPromotionJoinDate: 'Fecha en la que se unió',
            vehicleNumber: 'Número de vehículo',
            paymentCard: 'Tarjeta de pago',
            cardType: 'Tipo de tarjeta',
            cardNumber: 'N.º de tarjeta (últimos 4 dígitos)',
            cardTitle: 'Título de la tarjeta',
            cardExpiry: 'Fecha de caducidad de la tarjeta',
            paymentServiceProvider: 'Proveedor de servicios de pago',
            viewReferral: 'Ver recomendación',
            referralDetails: 'Detalles de la recomendación',
            referrer_name: 'Nombre de la persona que recomienda',
            referral_name: 'Nombre de la recomendación',
            referral_bonus: 'Bono de recomendación',
            referralBonusStatus: 'Estado del bono de recomendación',
            referee_Name: 'Nombre de la persona recomendada',
            noRecords: 'No hay registros que mostrar',
            noReferralsMessage: 'No hay recomendación(es)',
            referrerName: 'Nombre del que recomienda a la persona recomendada:',
            referralCode: 'Código de recomendación de la persona que recomienda:',
            noReferrerMessage: 'No hay persona que recomienda',
            current_balance: 'Saldo actual',
            referral_balance: 'Saldo de recomendación',
            account_balance: 'Saldo de cuenta',
            rewards_balance: 'Saldo de recompensas',
            balanceDetails: 'Detalles de saldo',
            pending_transactions_details: 'Detalles de las Transacciones Pendientes',
            pending_balance: 'Saldo Pendiente',
            federated_account_type: 'Tipo de cuenta federada',
            pending: 'Pendiente',
            rfidCard: 'Tarjeta RFID',
            startCharge: 'Iniciar carga remota',
            chargeLocation: 'Ubicación',
            chargeStation: 'Estación',
            connector: 'Conector',
            limitedKWH: 'kWh limitados:',
            confirmationNote:
                'Para que la cuenta sea segura, confirme el nombre, el apellido, la línea de dirección 1 y el código postal del conductor individual antes de iniciar la carga remota. Marque la casilla después de la confirmación del cliente',
            fullName: 'Nombre completo',
            phoneNo: 'Número de teléfono',
            confirmationNoteFleet: 'Confirme esta contraseña con el conductor:',
            chargingStartedMessage: 'Solicitud de iniciar carga remota presentada satisfactoriamente',
            resetPassword: 'Restablecer contraseña',
            password: 'Contraseña',
            disablePaymentCard: 'Deshabilitar tarjeta de pago',
            requestedData: 'Datos solicitados',
            apiURL: 'API',
            viewData: 'Ver datos',
            deletionEmailSent: 'Enviado correo electrónico de eliminación de cuenta',
            yes: 'Sí',
            onstop: 'En parada',
            badDebtor: 'Moroso/a',
            available: 'Disponible',
            languagePreference: 'Preferencia de idioma',
            fakeAccount: 'Cuenta falsa',
            addNotes: 'Añadir notas',
            newNote: 'Nota nueva',
            addNote: 'Añadir nota',
            existingNotes: 'Notas existentes',
            viewNotes: 'Ver notas',
            notes: 'Notas',
            financialDetails: 'Datos financieros',
            uniqueID: 'ID único',
            dateGenerated: 'Fecha de creación',
            debtValue: 'Valor de deuda',
            letterTemplate: 'Modelo de carta usado',
            lastCardValidationDate: 'Fecha de validación de la última tarjeta',
            cancelPendingTransactions: 'Cancelar Transacciones Pendientes',
            cancelTransactions: 'Cancelar Transacciones',
        },
        pendingTransaction: {
            label: {
                chargeLocation: 'Ubicación',
                chargeStation: 'Estación de Carga',
                sessionId: 'ID de Sesión',
                sessionStatus: 'Estado de la Sesión',
                amount: 'Importe',
                createdDate: 'Fecha de Creación',
            },
            button: {
                settle: 'Cantidad',
                cancel: 'Cancelar',
            },
        },
        account_type: {
            driver: 'Conductor',
            vehicle: 'Vehículo',
        },
        payment_type: {
            credit_account: 'Cuenta de crédito',
            prepayment_account: 'Cuenta de prepago',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            sendEmail: 'Enviar correo electrónico',
            viewTransactions: 'Ver transacciones',
            close: 'Cerrar',
            startCharge: 'Iniciar carga remota',
            startChargeBtn: 'Iniciar carga',
            resetPassword: 'Restablecer contraseña',
            submit: 'Enviar',
            amendBalance: 'Modificar saldo',
            viewActivities: 'Ver actividades',
            premiumSubscriptions: 'Suscripciones premium',
            markAsFake: 'Marcar como cuenta falsa',
            addNotes: 'Añadir notas',
            debtLetterHistory: 'Historial de cartas de deuda',
            enableReferralCode: 'Habilitar código de recomendación',
            disableReferralCode: 'Deshabilitar código de recomendación',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            sendMailConfirmMessage: '¿Está seguro/a de que desea enviar el correo electrónico?',
            mailSentSuccessMessage: 'Correo electrónico enviado satisfactoriamente.',
            resetPasswordConfirmMesage: '¿Está seguro/a de que desea restablecer la contraseña para este usuario?',
            deleteDriverConfirmMesage: '¿Está seguro/a de que desea eliminar la cuenta de este conductor?',
            markAsFakeConfirmMessage:
                '¿Desea marcar esta cuenta de conductor como falsa? Es un proceso irreversible en el que se elimina la información.',
            enableReferralCodeConfirmMesage:
                '¿Está seguro/a de que desea habilitar el código de recomendación para este conductor?',
            disableReferralCodeConfirmMesage:
                '¿Está seguro/a de que desea deshabilitar el código de recomendación para este conductor?',
            cancelPendingTransactionsConfirmMesage:
                '¿Está seguro de que desea cancelar las transacciones pendientes seleccionadas?',
        },
        errors: {
            driverGroups: {
                required: 'Seleccione al menos un grupo de conductor',
            },
            organization: {
                required: 'Seleccione una organización',
            },
            tag: {
                invalid_fromat: 'Caracteres no válidos en etiqueta',
            },
            fullName: {
                valid: 'Introduzca un nombre válido',
            },
            phoneNo: {
                match: 'Introduzca un número de teléfono válido',
            },
            email: {
                required: 'Introduzca la dirección de correo electrónico',
                email: 'Introduzca una dirección de correo electrónico válida',
            },
            password: {
                passwordFormat:
                    'La contraseña debe incluir al menos 10 caracteres, y al menos una mayúscula, una minúscula, un carácter especial y un número.',
            },
        },
    },
    driverGroup: {
        title: 'Grupos de conductor: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        titleFleet: 'Grupos: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        manageDriverGroup: 'Administrar grupo de conductor',
        manageDriverGroupFleet: 'Administrar grupo',
        driversList: 'Conductores',
        driversListFleet: 'Conductores/vehículos',
        header: 'Grupos de conductor',
        headerFleet: 'Grupos',
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            edit: 'Editar',
            delete: 'Eliminar',
            save: 'Guardar',
            cancel: 'Cancelar',
            yes: 'Sí',
            no: 'No',
            action: 'Acción',
            add: 'Añadir',
            back: 'Atrás',
            enable: 'Permitir',
            disable: 'Deshabilitar',
        },
        placeholder: {
            groupName: 'Nombre del grupo',
            drivers: 'Seleccionar conductores',
            driversFleet: 'Seleccionar conductores/vehículos',
            select: 'Seleccionar estado',
            selectType: 'Seleccionar tipo',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
        },
        label: {
            id: 'ID',
            name: 'Nombre',
            description: 'Descripción',
            organization: 'Organización',
            createdBy: 'Creado por',
            status: 'Estado',
            modifiedBy: 'Modificado por',
            createdDate: 'Fecha de creación',
            modifiedDate: 'Fecha de modificación',
            action: 'Acción',
            groupName: 'Nombre del grupo',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            phoneNo: 'Número de teléfono',
            email: 'Dirección de correo electrónico',
            groupAccess: 'Acceso de grupo',
            selectDrivers: 'Seleccionar conductores',
            selectDriversFleet: 'Seleccionar conductores/vehículos',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            yes: 'Sí',
            no: 'No',
            vehicle_number: 'N.º de vehículo',
            type: 'Tipo',
            updateDriverAssociation: 'Actualizar asociación de conductor',
            addToThisGroup: 'Añadir a este grupo',
            cancel: 'Cancelar',
        },
        form: {
            groupName: {
                label: 'Nombre del grupo',
                placeholder: 'Introduzca el nombre del grupo',
            },
            description: {
                label: 'Descripción',
                placeholder: 'Introduzca la descripción',
            },
        },
        errors: {
            groupName: {
                required: 'Introduzca el nombre del grupo',
                valid: 'Introduzca un nombre de grupo válido',
                max: 'Se permite un máximo de 50 caracteres',
            },
            description: {
                max: 'Se permite un máximo de 255 caracteres',
            },
            driverList: {
                required: 'Seleccione al menos un conductor',
                requiredfleet: 'Seleccione al menos un conductor/vehículo',
            },
            spendLimit: {
                valid: 'Introduzca al menos un valor límite de gasto',
            },
        },
    },
    vat: {
        title: 'IVA: ##COMPANY_BRAND_NAME##',
        vat: 'IVA',
        manageVat: 'Administrar IVA',
        label: {
            name: 'Nombre',
            description: 'Descripción',
            rate: 'Tasa',
            createdDate: 'Fecha de creación',
            action: 'Acción',
            status: 'Estado',
            disabled: 'Deshabilitado',
            enabled: 'Permitido',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            defaultVAT: 'IVA por defecto',
            yes: 'Sí',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            setDefaultConfirmMesage: '¿Está seguro/a de que desea establecer este IVA como IVA por defecto?',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Añadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            setDefaultVAT: 'Establecer por defecto',
        },
        placeholder: {
            select: 'Seleccionar estado',
            name: 'Nombre',
            description: 'Descripción',
            rate: 'Tasa',
        },
        errors: {
            name: {
                valid: 'Introduzca un nombre válido.',
            },
            rate: {
                max: 'La tasa no puede ser superior a 100',
                min: 'La tasa no puede ser inferior a 0',
                number: 'La tasa debe ser un número',
            },
            description: {
                valid: 'Introduzca un descripción válida',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Sí',
            no: 'No',
            proceed: 'Continuar',
            cancel: 'Cancelar',
        },
    },
    tag: {
        title: 'Etiquetas: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        tag: 'Etiquetas',
        manageUser: 'Administrar usuarios',
        placeholder: {
            name: 'Nombre de etiqueta',
            select: 'Seleccionar',
        },
        label: {
            name: 'Nombre de etiqueta',
            driver_count: 'Número de conductores',
            charge_location_count: 'Número de ubicaciones de carga',
            action: 'Acción',
            delete: 'Eliminar',
            editHeader: 'Editar etiqueta',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Añadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
        },
        message: {
            deleteConfirmMesage:
                'La etiqueta se eliminará de todos los conductores asociados y de la ubicación de carga. ¿Está seguro/a de que desea eliminarlo?',
        },
        errors: {
            name: 'Caracteres no válidos en etiqueta',
        },
    },
    chargeStation: {
        title: 'Estaciones de carga: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        chargeStations: 'Estaciones de carga',
        manageVat: 'Administrar estación de carga',
        label: {
            modifiedDate: 'Fecha de modificación',
            importChargeStationHeader: 'Importar estación de carga',
            csvFile: 'Archivo CSV',
            manageAmenities: 'Administrar servicios',
            chargePoint: 'Punto de carga',
            allLocations: 'Todas ubicaciones',
            assignedLocation: 'Ubicaciones asignadas',
            unassignedLocation: 'Ubicaciones no asignadas',
            chargeLocation: {
                cp_id: 'CP-Id',
                type: 'Tipo',
                name: 'Nombre',
                locationName: 'Nombre de la ubicación',
                address: 'Dirección',
                city: 'Ciudad',
                postal_code: 'Código postal',
                chargePoint: 'Punto de carga',
                appliesToOrg: 'Aplicable a la organización',
                associatedTariff: 'Tarifa asociada',
                associatedPromotion: 'Promoción asociada',
                gmbLocationId: 'ID de ubicación de GMB',
            },
            chargeStation: {
                uid: 'UId',
                evse_id: 'ID de EVSE',
                status: 'Estado',
                physicalReference: 'Referencia física',
                city: 'Ciudad',
                postal_code: 'Código postal',
            },
            stationConnector: {
                connector_id: 'ID de conector',
                standard: 'Estándar',
                format: 'Formato como tipo',
                power_type: 'Tipo de potencia',
                voltage: 'Voltaje',
                amperage: 'Amperaje',
                power_rating: 'Potencia nominal',
            },
            selectTag: 'Seleccionar etiquetas',
            addTagHeader: 'Etiquetas de asociados',
            tags: 'Etiquetas',
            yes: 'Sí',
            assignedTariff: 'Asignar tarifa',
            assignTariff: 'Asignar tarifa a ubicaciones',
            delete: 'Eliminar',
            action: 'Acción',
            addPromotion: 'Añadir promoción',
            selectPromotion: 'Seleccionar promoción',
            exportChargeStations: {
                connector_id: 'connector_id',
                max_power: 'max_power',
                cp_id: 'cp_id',
                type: 'tipo',
                location: 'ubicación',
                station_name: 'station_name',
                address: 'dirección',
                city: 'ciudad',
                postal_code: 'postal_code',
                country: 'país',
                latitude: 'latitud',
                longitude: 'longitud',
                evse_id: 'evse_id',
                standard: 'estándar',
                format: 'formato',
                powertype: 'tipodepotencia',
                voltage: 'voltaje',
                amperage: 'amperaje',
            },
            gmbLocationID: 'ID de ubicación de GMB',
            clickHere: 'Haga clic aquí',
            downloadTemplate: 'para descargar la plantilla',
            importStationsModel: 'Importar modelo de estaciones de carga',
            noDataToExport: 'No hay datos que exportar.',
            note: 'Nota:',
            autoCalculateMaxPowerNote:
                'Algunos CPO se han configurado para calcular automáticamente la potencia máxima, si se usa esta importación podría sobrescribir esos valores calculados.',
            applyToOrg: 'Aplicar a toda la organización',
        },
        errors: {
            tag: {
                invalid_fromat: 'Caracteres no válidos en etiqueta',
            },
            file: {
                fileType: 'Se permite cargar un archivo con la extensión ".csv".',
            },
            gmbLocationId: {
                valid: 'Introducir ID de ubicación de GMB válido',
            },
            common: 'Algo ha fallado. Vuelva a intentarlo',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Guardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            expand: 'Expandir',
            collapse: 'Contraer',
            import: 'Importar',
            synchronize: 'Sincronizar',
            syncStation: 'Sincronizar estación',
            assignTariff: 'Asignar tarifa',
            delete: 'Eliminar',
            add: 'Añadir',
            addSelected: 'Añadir seleccionado',
            addAll: 'Añadir todo',
            yes: 'Sí',
            no: 'No',
            back: 'Atrás',
            apply: 'Aplicar',
            editGMBLocationID: 'Editar ID de ubicación de GMB',
            downloadLocationsData: 'Extraer datos de ubicaciones de carga',
            exportAll: 'Exportar todo',
            importStationsModel: 'Importar modelo de estaciones de carga',
            deleteSelected: 'Eliminar seleccionados',
            export: 'Exportar',
        },
        placeholder: {
            selectStationStatus: 'Seleccionar estado',
            name: 'Nombre',
            cp_id: 'CP-Id',
            tags: 'Etiquetas',
            address: 'Dirección',
            selectTag: 'Seleccionar etiqueta',
            evse_id: 'ID de EVSE',
            selectChargePoint: 'Seleccionar CPOs',
            selectPromotion: 'Seleccionar promoción',
            gmbLocationID: 'ID de ubicación de GMB',
            selectPowerType: 'Seleccionar tipo de potencia',
            selectRegion: 'Seleccionar región',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            addPromotion: 'Datos de la promoción actualizados satisfactoriamente',
            updateAmenitiesSuccess: 'Servicios de ubicación de carga actualizados satisfactoriamente',
            chargePointRequire: 'Es necesario al menos un punto de carga',
            deleteBulkConfirmMessage: '¿Está seguro/a de que desea eliminar los registros seleccionados?',
            applyToAllOrgConfirmMessage:
                '¿Le gustaría aplicar esta tarifa también a las organizaciones para todas las ubicaciones?',
        },
        manageAmenities: 'Administrar servicios',
    },
    chargeStationMap: {
        title: 'Vista de mapa de estaciones de carga: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Estaciones de carga',
        label: {
            address: 'Dirección',
            backOfficeUrl: 'URL de Back Office:',
            amenities: 'Servicios:',
            satellite: 'Satélite',
            map: 'Mapa',
            search: 'Buscar',
            refresh: 'Actualizar',
            apply: 'Aplicar',
            clear: 'Borrar',
            loading: 'Cargando...',
        },
        placeholder: {
            locationSearch: 'Buscar estación',
            mapSearch: 'Buscar por nombre de calle, ciudad o código postal',
        },
    },
    promotionsRequest: {
        headerTitle:
            'Solicitud de promociones de conductor - Plataforma de Servicios eMobility de ##COMPANY_BRAND_NAME##',
        title: 'Solicitud de promociones de conductor',
        promotionsRequest: 'Promociones solicitadas',
        columns: {
            driverName: 'Nombre del conductor',
            promotionsName: 'Nombre de la promoción',
            promotionsCode: 'Código',
            approved: 'Estado',
            approvedBy: 'Modificado por',
            approvedDate: 'Fecha de modificación',
            action: 'Acción',
            email: 'Correo electrónico',
        },
        form: {
            charge: 'Cargando',
            payment: 'Pago',
            month: 'Mes',
        },
        label: {
            approved: 'Aprobado',
            pending: 'Pendiente',
            rejected: 'Rechazado',
            modelHeader: 'Promoción solicitada -',
            enterComment: 'Introduzca sus comentarios',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Atrás',
            approved: 'Aprobar',
            pending: 'Pendiente',
            rejected: 'Rechazar',
            action: 'Acción',
            edit: 'Editar',
        },
        placeholder: {
            driverName: 'Nombre del conductor',
            promotionsName: 'Nombre de la promoción',
            promotionsCode: 'Código',
            select: 'Seleccionar estado',
        },
        message: {
            ManagestatusMesage:
                'Haga clic en Aprobado o Rechazado para aplicar el estado de la solicitud. Cuando se haya actualizado esta solicitud, ya no podrá editarse.',
        },
    },
    driverAccountBalance: {
        title: 'Saldo de cuenta de conductor: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        driverAccountBalance: 'Saldo de cuenta de conductor',
        manageUser: 'Administrar saldo de cuenta de conductor',
        placeholder: {
            name: 'Nombre/correo electrónico',
            select: 'Seleccionar estado',
            payment_type: 'Seleccionar tipo de pago',
            description: 'Comentario',
            amount: 'Introducir el importe de crédito/débito',
        },
        label: {
            name: 'Nombre',
            email: 'Correo electrónico',
            payment_type: 'Tipo de pago',
            driver_status: 'Estado de la cuenta',
            current_balance: 'Saldo',
            currency: 'Divisa',
            driver_id: 'ID del conductor',
            action: 'Acción',
            delete: 'Eliminar',
            refundHeader: 'Retirada',
            creditPayment: 'Cuenta de crédito',
            prePayment: 'Cuenta de prepago',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            refund: 'Modificar saldo de cuenta',
            description: 'Comentario',
            amount: 'Introducir el importe de crédito/débito',
            additional_payment: 'Pago adicional',
            payment_refunds: 'Retiradas de pago',
            payment_settlement: 'Modificación de saldo - Solicitud',
            balance: 'Tipo de saldo',
            accountBalance: 'Fondos de la cuenta',
            referralBonus: 'Bono de recomendación',
            rewardBalance: 'Saldo de recompensas',
            total_balance: 'Saldo total',
            rewards: 'Recompensas',
            pendingBalance: 'Saldo Pendiente',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Añadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            send_for_approval: 'Enviar para aprobación',
        },
        message: {
            deleteConfirmMesage:
                'La etiqueta se eliminará de todos los conductores asociados y de la ubicación de carga. ¿Está seguro/a de que desea eliminarlo?',
        },
        errors: {
            name: 'Caracteres no válidos en etiqueta',
            amount: {
                moreThan: 'La cantidad debe ser superior/inferior a 0',
                maxcredit: 'Se ha alcanzado el límite máximo de crédito de la cuenta',
                maxdebit: 'Se ha alcanzado el límite máximo de débito de la cuenta',
            },
        },
    },
    driverPromotions: {
        title: 'Administrar promoción: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        manageDriverPromotion: 'Administrar promoción',
        driverPromotions: 'Promociones',
        label: {
            name: 'Nombre',
            code: 'Código',
            errorMessage: 'Mensaje de error',
            used: 'Usado',
            unUsed: 'No usado',
            uploadFileErrorMessage: 'Se han producido errores al cargar los códigos de promoción',
            updatePromotionCode: 'Actualizar código de promoción',
            unique_code: 'Código único',
            uniquePromotionCode: 'Códigos de promoción',
            importDriverPromotionCodeHeader: 'Importar código de promoción de conductor',
            csvFile: 'Códigos de promoción',
            promotionCode: 'Código de promoción',
            usedBy: 'Usado por',
            description: 'Descripción',
            tarrif: 'Tarifa',
            accountCredit: 'Crédito de cuenta',
            discountRatePeriod: 'Periodo de la tasa de descuento',
            indays: '(Días)',
            intilakWhRate: 'Tarifa inicial por kWh',
            ivRewardsPromotion: 'IV Promociones de recompensas',
            referralPromotion: 'Promoción de recomendaciones',
            expiryDate: 'Fecha de caducidad',
            needApprovalToJoinPromotion: 'Necesita aprobación para unirse a la promoción',
            newDriversOnly: 'Solo nuevos conductores',
            forOrganisation: 'Para la organización',
            createdDate: 'Fecha de creación',
            action: 'Acción',
            status: 'Estado',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            deleted: '(Eliminado)',
            csvFileSupported: 'Solo se admiten archivos CSV',
            clickHere: 'Haga clic aquí',
            downloadTemplate: 'para descargar el modelo',
            exportColumnHeder: 'códigos_promoción',
            min_kwh_package_promotion: 'Mínimo de kWh',
            package_promotion_period: 'Periodo de promoción de paquete (Días)',
            package_promotion_volt_bonus: 'Número de Volts de recompensa concedidos',
            rfidCardUnitPrice: 'Precio unitario de tarjeta RFID',
            subscription: 'Suscripción premium',
            tariffUpdate: 'Actualización de tarifa',
            currentTariff: 'Tarifa actual',
            next: 'Siguiente',
            newTariff: 'Tarifa nueva',
            save: 'Guardar',
        },
        placeholder: {
            name: 'Nombre',
            promotionCode: 'Código de promoción',
            selectTariff: 'Seleccionar tarifa',
            selectStatus: 'Seleccionar estado',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de fin',
            forOrganisation: 'Para la organización',
            min_kwh_package_promotion: 'Mínimo de kWh',
            package_promotion_period: 'Periodo de promoción de paquete',
            package_promotion_volt_bonus: 'Número de Volts de recompensa concedidos',
            rfidCardUnitPrice: 'Precio unitario de tarjeta RFID',
            premium_subscription: 'Suscripción premium',
            selectCurrentTariff: 'Seleccionar tarifa actual',
            selectNewTariff: 'Seleccionar tarifa nueva',
        },
        button: {
            update: 'Actualizar',
            import: 'Importar',
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Añadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            subscriptionChangeWarningMessage:
                'Atención: Al cambiar el tipo de suscripción, se cancelarán todas las renovaciones automáticas de la cuenta del conductor.',
            tariffUpdateNote: 'Se asignará la nueva tarifa a las siguientes promociones:',
            updateTariffConfirmMessage:
                '¿Está seguro/a de que desea actualizar la tarifa para las promociones seleccionadas?',
            selectOneRecord: 'Seleccione al menos una promoción para actualizar la tarifa',
        },
        errors: {
            promotionName: {
                valid: 'Introduzca un nombre de promoción válido',
            },
            promotionCode: {
                valid: 'Introduzca un código de promoción válido',
            },
            accountCredit: {
                moreThan: 'El crédito de cuenta debe ser superior a 0',
                max: 'Se ha alcanzado el límite máximo de crédito de la cuenta',
                typeError: 'Introduzca una cantidad válida de crédito de cuenta',
            },
            discountRatePeriod: {
                moreThan: 'El periodo de la tasa de descuento debe ser superior a 0',
            },
            intialRate: {
                max: 'El tipo no puede ser superior a 100',
                min: 'El tipo no puede ser inferior a 0',
                typeError: 'Introduzca una tasa válida',
            },
            common: 'Algo ha fallado, vuelva a intentarlo.',
            file: {
                fileType: 'Se permite cargar un archivo con la extensión ".csv".',
            },
            maxValue: 'El valor máximo no debe ser superior a 2147483647',
            rfidCardUnitPrice: {
                max: 'El precio unitario de la tarjeta RFID no puede ser superior a 1000',
            },
        },
    },
    paymentApproval: {
        headerTitle: 'Aprobaciones de saldo de cuenta - ##COMPANY_BRAND_NAME##: Carga rápida de VE Reino Unido',
        title: 'Aprobaciones de saldo de cuenta',
        transaction: 'Transacción',
        columns: {
            email: 'Correo electrónico',
            amount: 'Cantidad',
            status: 'Estado',
            request_by: 'Solicitado por',
            request_date: 'Solicitado el',
            request_by_comment: 'Solicitado por Comentarios',
            review_by: 'Reseñado por',
            review_date: 'Reseñado el',
            review_comment: 'Comentarios del autor de la reseña',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Cerrando',
            transaction: 'ID de transacción',
            name: 'Nombre',
            action: 'Acción',
            request_type: 'Tipo de solicitud',
            invoice: 'Factura',
        },
        form: {
            driver: 'Conductor',
            organisation: 'Organización',
            month: 'Mes',
        },
        label: {
            request_type: 'Tipo de solicitud',
            refundHeader: 'Modificación de saldo',
            pending: 'Pendiente',
            approved: 'Aprobar',
            declined: 'Rechazar',
            approve: 'Aprobar',
            decline: 'Rechazar',
            comment: 'Introduzca sus comentarios',
            status: 'Estado',
            refund: 'Aprobar Crédito/Débito',
            refundAmount: 'Cantidad de retirada',
            commentsFrom: 'Comentarios de',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
        },
        placeholder: {
            comment: 'Introduzca sus comentarios',
            status: 'Seleccionar estado',
            name: 'Nombre/correo electrónico',
            refundAmount: 'Cantidad de retirada',
        },
        message: {
            noDataToExport: 'No hay datos que exportar.',
            selectApprovalOrReject: 'Apruebe/rechace esta solicitud.',
        },
    },
    paymentScheduleSetting: {
        title: 'Configuración del calendario de pagos: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Calendario de pagos',
        note: 'Programar un proceso en segundo plano para liquidar las facturas pendientes de carga de VE realizada por los conductores.',
        placeholder: {
            day_of_week: 'Día de la semana',
        },
        label: {
            daily: 'Diario',
            weekly: 'Semanal',
            day_of_week: 'Día de la semana',
            selectDay: 'Seleccione el día',
        },
        day_of_week: {
            monday: 'LUNES',
            tuesday: 'MARTES',
            wednesday: 'MIÉRCOLES',
            thursday: 'JUEVES',
            friday: 'VIERNES',
            saturday: 'SÁBADO',
            sunday: 'DOMINGO',
        },
        button: {
            save: 'Guardar',
        },
    },
    paymentFailures: {
        title: 'Errores de pago: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        managePaymentFailures: 'Errores de pago',
        placeholder: {
            name: 'Nombre/correo electrónico',
            note: 'Observación',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de fin',
            select: 'Seleccionar estado',
            status: 'Seleccionar estado',
            failureReason: 'Motivo del error',
        },
        label: {
            name: 'Nombre',
            email: 'Correo electrónico',
            transaction_id: 'ID de transacción',
            total_amount: 'Importe total',
            currency_name: 'Divisa',
            created_date: 'Fecha de creación',
            status: 'Estado',
            note: 'Observación',
            action: 'Acción',
            editHeader: 'Actualizar estado del pago',
            pending: 'Pendiente',
            acknowledged: 'Reconocido',
            closed: 'Cerrado',
            transactionDetails: 'Detalles de la transacción',
            transaction_request: 'Solicitud de transacción',
            transaction_response: 'Respuesta de transacción',
            error_message: 'Mensaje de error',
            error_code: 'Código de error',
            request_type: 'Tipo de solicitud',
            response_code: 'Código de respuesta',
            response_code_description: 'Descripción del código de respuesta',
            null_data: 'No se han encontrado datos',
            transaction_date: 'Fecha de transacción',
            failureReason: 'Motivo del error',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Añadir',
            edit: 'Editar estado',
            reset: 'Restablecer',
            yes: 'Sí',
            no: 'No',
            action: 'Acción',
            back: 'Atrás',
        },
    },
    chargeTariff: {
        title: 'Tarifas: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Tarifas',
        tariff: 'Tarifa',
        label: {
            name: 'Nombre',
            vat_name: 'Nombre de IVA',
            vat_rate: 'Tasa (%)',
            vat_description: 'Descripción',
            cpo_id: 'ID de cpo',
            action: 'Acción',
            url: 'URL',
            currency: 'Divisa',
            createdDate: 'Fecha de creación',
            status: 'Estado',
            enabled: 'Permitido',
            deleted: 'Eliminado',
            detail: 'Detalles',
            promotions: 'Promociones',
            lastUpdated: 'Última actualización',
            promotionCode: 'Código de promoción',
            description: 'Descripción',
            expiryDate: 'Fecha de caducidad',
            priceComponents: 'Componentes del precio',
            priceComponent: 'Componente del precio',
            type: 'TIPO',
            price: 'PRECIO',
            pricePerHour: 'Precio (por hora)',
            restriction: 'Restricción',
            startDate: 'Fecha de inicio',
            startTime: 'Hora de inicio',
            endDate: 'Fecha de finalización',
            endTime: 'Hora de finalización',
            minkWh: 'kWh mín.',
            maxkWh: 'kWh máx.',
            minPower: 'Potencia Mín.',
            maxPower: 'Potencia Máx.',
            minDuration: 'Duración Mín',
            maxDuration: 'Duración Máx',
            weekDays: 'Días de la semana',
            selectVat: 'Seleccionar IVA',
            attachVat: 'Fijar IVA',
            vatdetail: 'Detalles de IVA',
            editVAT: 'Editar tipo de IVA',
            vatType: 'Tipo de IVA',
            tariffID: 'ID de tarifa',
            element: 'ELEMENTO',
            prices: 'Precios',
            restrictions: 'Restricciones',
            stepSize: 'GRANULARIDAD',
            vat: 'IVA',
            date: 'FECHA',
            time: 'HORA',
            kwh: 'KWH',
            power: 'POTENCIA (KW)',
            duration: 'DURACIÓN (SEC)',
            current: 'CORRIENTE (AMP)',
            maxCurrent: 'Corriente Máxima',
            minCurrent: 'Corriente Mínima',
            restrictionTitle: 'RESTRICCIÓN',
            details: 'Detalles',
            weekDaysTitle: 'DÍAS DE LA SEMANA',
            maxKwhTitle: 'KWH Máximo',
            minKwhTitle: 'KWH Mínimo',
        },
        placeholder: {
            name: 'Nombre',
            selectStatus: 'Seleccionar estado',
            selectVat: 'Seleccionar IVA',
            selectType: 'Seleccionar tipo de IVA',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            edit: 'Editar',
            detail: 'Detalles',
            add: 'Añadir',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            editvat: 'Fijar IVA',
            editVAT: 'Editar tipo de IVA',
            groupRestrictions: 'Restricciones de Tarifa de Grupo',
            ungroupRestrictions: 'Restricciones de Tarifa No Agrupada',
        },
        noRestrictionAvailable: 'No Hay Restricciones Disponibles',
    },
    partnerPromotion: {
        title: 'Promociones de socios: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Promociones de socios',
        placeholder: {
            nameorcompany: 'Nombre o empresa',
            status: 'Seleccionar estado',
            date_from: 'Fecha de inicio',
            date_to: 'Fecha de finalización',
        },
        label: {
            name: 'Nombre',
            company: 'Empresa',
            description: 'Descripción',
            date_from: 'Fecha de inicio',
            date_to: 'Fecha de finalización',
            expiry_date: 'Fecha de caducidad',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            delete: 'Eliminar',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Añadir',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            chargeStation: 'Estaciones de carga',
            preview: 'Vista previa',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
        },
        insert: {
            header: 'Administrar promociones de socios',
            placeholder: {
                name: 'Nombre',
                company: 'Información de la empresa',
                description: 'Descripción',
                start_date: 'Fecha de inicio',
                expiry_date: 'Fecha de caducidad',
                offer_duration: '60 minutos',
                stored_for_future_use_days: '2 días',
                qr_code_details: 'Información de código QR',
                certificate: 'Certificado',
                image: 'Imagen de oferta',
                image1: 'Imagen adicional 1',
                image2: 'Imagen adicional 2',
                image3: 'Imagen adicional 3',
                image4: 'Imagen adicional 4',
                image5: 'Imagen adicional 5',
                banner_image: 'Logotipo de promoción',
                locationPageImage: 'Imagen de página de ubicación',
                displayOnChargeLocation: 'Mostrar pantalla de ubicación en carga',
                promotion_button_text: 'Texto de botón de promoción',
            },
            label: {
                name: 'Nombre',
                company: 'Empresa',
                description: 'Descripción',
                start_date: 'Fecha de inicio',
                expiry_date: 'Fecha de caducidad',
                offer_duration: 'Duración de la oferta (Minutos)',
                stored_for_future_use_days: 'Guardar para usar más adelante (días)',
                always_display_on_partner_promotion: 'Mostrar siempre promoción de socio',
                qr_code_details: 'Código QR',
                certificate: 'Certificado',
                image: 'Imagen de oferta',
                banner_image: 'Logotipo de promoción (1030 X 430)',
                layout: 'Disposición de pantalla',
                note1: 'Tenga en cuenta que debe mencionar <strong>##image##</strong> y el <strong>##qrcode##</strong> en el HTML de disposición de pantalla para reemplazar los detalles respectivos según corresponda. Se pueden añadir imágenes adicionales a una disposición usando el código ##image0X##, donde X puede estar entre 1 y 5.',
                qr_code_note:
                    'Tenga en cuenta que debe mencionar <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> y <strong>##ChargeStationAddress##</strong>  en el QR para reemplazar los detalles respectivos según corresponda.',
                locationPageImage: 'Imagen de página de ubicación',
                displayOnChargeLocation: 'Mostrar pantalla de ubicación en carga',
                partner_promotion_display_type: 'Tipo de visualización de promoción',
                promotion_button_text: 'Texto de botón de promoción',
                open_external_url: 'Abrir URL externa',
                external_url: 'URL externa',
                image1: 'Imagen adicional 1',
                image2: 'Imagen adicional 2',
                image3: 'Imagen adicional 3',
                image4: 'Imagen adicional 4',
                image5: 'Imagen adicional 5',
            },
            errors: {
                common: 'Algo ha fallado, vuelva a intentarlo.',
                name: {
                    valid: 'Introduzca un nombre de promoción válido',
                    max: 'El nombre de la promoción es demasiado largo',
                },
                description: {
                    max: 'La descripción de la promoción es demasiado larga',
                },
                offer_duration: {
                    moreThan: 'La duración de la oferta debe ser superior a 0',
                    max: 'La duración de la oferta no puede ser superior a 60 minutos',
                },
                stored_for_future_use_days: {
                    moreThan: 'El día de guardado para un uso futuro debe ser superior a 0',
                    max: 'El día de guardado para un uso futuro no puede ser superior a 99 días',
                },
                banner_image: {
                    dimensions: 'El logotipo de promoción debe tener unas dimensiones de 1030 X 430',
                },
                image: {
                    fileType: 'Se pueden subir archivos con las extensiones ".jpg", ".png", ".svg", ".jpeg"',
                    location_page_image: 'La imagen de página de ubicación es un archivo necesario',
                },
                certificate: {
                    fileType: 'Se permite cargar un archivo con la extensión ".crt", ".cer"',
                },
                promotion_button_text: {
                    valid: 'Introducir un texto de botón de promoción válido',
                },
                external_url: {
                    url: 'La URL externa debe ser una URL válida',
                },
            },
        },
        assign: {
            header: 'Estaciones de carga',
            headerModal: 'Estación de carga',
            placeholder: {
                name: 'Introduzca el nombre',
                locationName: 'Introduzca el nombre de la ubicación',
                address: 'Dirección',
                tags: 'Seleccionar etiquetas',
            },
            label: {
                add: 'Añadir',
                name: 'Nombre',
                type: 'Tipo',
                address: 'Dirección',
                city: 'Ciudad',
                postcode: 'Código postal',
                last_updated: 'Fecha de modificación',
                action: 'Acción',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            },
        },
    },
    CPOInterface: {
        title: 'Cuentas: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Cuentas',
        placeholder: {
            name: 'Nombre',
            status: 'Seleccionar estado',
        },
        label: {
            name: 'Nombre',
            party_id: 'ID de la parte',
            country_code: 'Código de país',
            version_url: 'URL de la versión',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            locationGroup: 'Ubicación del grupo',
            yes: 'Sí',
            no: 'No',
            rfidDriverTokens: 'Compartir solo tokens RFID de conductor',
            vat_type: 'Tipo de IVA',
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: '##COMPANY_BRAND_NAME## CPO Internacional',
            cpo_type: 'Tipo de CPO',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Añadir',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablecer',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            getCredentials: 'Obtener credenciales',
            performHandshake: 'Realizar apretón de manos',
            reHandshake: 'Volver a realizar apretón de manos',
            generateHandshakeToken: 'Generar token de apretón de manos',
            reGenerateHandshakeToken: 'Regenerar token de apretón de manos',
            changeMutualOCPIVersion: 'Cambiar versión mutua OCPI',
            handshakeDetails: 'Detalles del apretón de manos',
        },
        message: {
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage:
                'Desactivar este CPO detendrá toda la comunicación OCPI, ocultará las ubicaciones de carga asociadas en las aplicaciones, marcará las estaciones de carga vinculadas como "Eliminadas" y eliminará las ubicaciones de los grupos de acceso. ¿Está seguro de que desea continuar?',
        },
        insert: {
            header: 'Administrar operador de punto de carga',
            placeholder: {
                name: 'Nombre',
                party_id: 'ID de la parte',
                country_code: 'Código de país',
                ocpi: 'Proveedor de Servicios eMobility',
                version_url: 'Versión URL de CPO',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                colour_code: 'Código de color',
                back_office_url: 'URL de Back Office',
                vat_type: 'Tipo de IVA',
                region: 'Seleccionar región',
                vat: 'Seleccionar IVA',
                cpo_type: 'Tipo de CPO',
            },
            label: {
                name: 'Nombre',
                party_id: 'ID de la parte',
                country_code: 'Código de país',
                ocpi: 'Proveedor de Servicios eMobility',
                version_url: 'URL de la versión',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                locationGroup: 'Ubicación del grupo',
                rfidDriverTokens: 'Compartir solo tokens RFID de conductor',
                colour_code: 'Código de color',
                back_office_url: 'URL de Back Office',
                vat_type: 'Tipo de IVA',
                disableLocationPatchPutRemovals: 'Deshabilitar eliminaciones de ubicación PATCH/PUT',
                enableLocationPatchPutRemovals: 'Habilitar eliminaciones de ubicación PATCH/PUT',
                enableAutoMaxPowerCalculation: 'Permitir cálculo automático de potencia máxima',
                mutual_ocpi_version: 'Versión OCPI mutua',
                externalCPO: 'Región asociada',
                is_external: '##COMPANY_BRAND_NAME## CPO Internacional',
                defaultVat: 'IVA por defecto (Reemplazar)',
                gmbAccountID: 'ID de cuenta de GMB',
                cpo_type: 'Tipo de CPO',
            },
            errors: {
                common: 'Algo ha fallado, vuelva a intentarlo.',
                name: {
                    valid: 'Introduzca un nombre de CPO válido',
                },
                party_id: {
                    valid: 'Introduzca un ID de parte válido',
                },
                country_code: {
                    valid: 'Introduzca un código de país válido',
                },
                version_url: {
                    url: 'La URL de la versión debe ser una URL válida',
                },
                colour_code: {
                    valid: 'Introduzca un código de color válido',
                },
                back_office_url: {
                    url: 'La URL del back office debe ser una URL válida',
                },
            },
        },
        versionEndpoints: {
            header: 'Terminales de versión',
            label: {
                version: 'Versión',
                identifier: 'Identificador',
                role: 'Función',
                url: 'URL',
                last_executed: 'Última actualización ejecutada el',
            },
        },
        modal: {
            message:
                'Está marcando esta CPO como CPO Internacional de ##COMPANY_BRAND_NAME##, deberá añadir estas ubicaciones de CPO manualmente en grupo de acceso público',
            okButton: 'De acuerdo',
        },
        confirmationModal: {
            header: 'Actualizar la Versión de OCPI Mutua',
            message: '¿Estás seguro de que quieres actualizar la versión OCPI mutua?',
        },
        performHandshakeModal: {
            handshakeHeader: 'Realizar apretón de manos',
            reHandshakeHeader: 'Volver a realizar apretón de manos',
            label: {
                mutual_ocpi_version: 'Versión mutua OCPI',
                version_url: 'URL de la versión',
                handshake_token: 'Token de apretón de manos',
            },
            placeholder: {
                mutual_ocpi_version: 'Versión mutua OCPI',
                version_url: 'URL de la versión',
                handshake_token: 'Token de apretón de manos',
            },
            button: {
                cancel: 'Cancelar',
                generateHandshakeToken: 'Generar token de apretón de manos',
                confirm: 'Confirmar',
                connect: 'Conectar',
                reconnect: 'Reconectar',
            },
            confirmationModal: {
                header: 'Realizar apretón de manos',
                rehandshakeMessage:
                    'Las credenciales CPO cambiarán después de volver a realizar el apretón de manos. ¿Está seguro de que desea continuar con el nuevo apretón de manos?',
                tokenGeneratedMessage:
                    'El token de apretón de manos para el CPO ya se ha generado. Si se entrega el token al CPO e intenta realizar un apretón de manos con el EMSP, podría fallar. ¿Está seguro de que desea continuar con el nuevo apretón de manos?',
            },
            cpoAuthTokenMessage: 'El valor predeterminado que se muestra aquí es el token de autenticación CPO',
        },
        generateHandshakeTokenModal: {
            header: 'Generar token de apretón de manos',
            reGenerateTokenHeader: 'Volver a generar token de apretón de manos',
            label: {
                handshakeToken: 'Token de apretón de manos',
                emsp_auth_token: 'Token de autenticación EMSP',
                emspVersionURL: 'URL de la versió EMSP',
            },
            Placeholder: {
                handshakeToken: 'Token de apretón de manos',
                emsp_auth_token: 'Token de autenticación EMSP',
            },
            button: {
                save: 'Guardar',
                copyToClipboard: 'Copiar al portapapeles',
                generateToken: 'Generar',
                reGenerateToken: 'Volver a generar',
                confirm: 'Confirmar',
                cancel: 'Cancelar',
            },
            copyToClipboard: {
                success: 'Token copiado al portapapeles',
                failed: 'Error al copiar el token',
            },
            confirmationModal: {
                confirmationMessage:
                    'Si se proporciona el token de apretón de manos anterior al CPO, podría fallar si el CPO intenta usarlo para el apretón de manos. ¿Está seguro de que desea guardar el nuevo token de apretón de manos?',
                header: 'Guardar token',
            },
            emspAuthTokenMessage: 'El valor predeterminado que se muestra aquí es el token de autenticación EMSP',
        },
        changeMutualOCPIVersionModal: {
            header: 'Cambiar versión mutua OCPI',
            label: {
                mutualOCPIVersion: 'Versión mutua OCPI',
            },
            button: {
                save: 'Guardar',
                cancel: 'Cancelar',
                confirm: 'Confirmar',
            },
            confirmationModal: {
                confirmationMessage: '¿Está seguro de que desea actualizar la versión mutua OCPI?',
            },
        },
        handshakeDetailsModal: {
            header: 'Detalles del apretón de manos',
            label: {
                version_url: 'URL de la versión',
                handshakeToken: 'Token de apretón de manos',
                emspAuthToken: 'Token de autenticación EMSP',
                cpoAuthToken: 'Token de autenticación CPO',
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Transferencias internas: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Transferencias internas',
        transferDetailTitle: 'Detalles de transferencia: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        transferDetailHeader: 'Detalles de transferencia',
        label: {
            transfer_id: 'ID de transferencia',
            gross_value: 'Valor bruto',
            created_date: 'Fecha de creación',
            action: 'Acción',
            transferNumber: 'Número de transferencia',
            transferDate: 'Fecha de transferencia',
            transaction: 'ID de transacción',
            transactionStartDate: 'Fecha de inicio de transacción',
            transactionEndDate: 'Fecha de finalización de transacción',
            publicCardId: 'ID de tarjeta pública',
            driverAccountId: 'ID de cuenta de conductor',
            driverName: 'N.º de conductor/vehículo',
            stationId: 'ID de estación',
            stationName: 'Nombre de la estación',
            stationAddress: 'Dirección de la estación',
            kwh: 'kWh',
            price_per_kwh: 'Precio/kWh',
            disable: 'DESHABILITADO',
        },
        placeholder: {
            start_date: 'Fecha de inicio',
            end_date: 'Fecha de finalización',
            status: 'Estado',
            cpo: 'Seleccionar CPO',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
        },
        errors: {
            cpo: {
                required: 'Seleccione CPO',
            },
        },
    },
    PSPSetting: {
        title: 'Proveedores de Servicios de Pago: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Proveedores de Servicios de Pago',
        placeholder: {
            name: 'Nombre',
            status: 'Seleccionar estado',
            type: 'Seleccionar tipo',
        },
        label: {
            name: 'Nombre',
            code: 'Código',
            type: 'Tipo',
            description: 'Descripción',
            store_name: 'Tienda',
            department_name: 'Departamento',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            details: 'Detalles',
            key: 'Clave',
            value: 'Valor',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Añadir',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablecer',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            getCredentials: 'Obtener credenciales',
            delete: 'Eliminar',
        },
        message: {
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
        },
        insert: {
            header: 'Administrar Proveedor de Servicios de Pago',
            placeholder: {
                name: 'Nombre',
                type: 'Tipo',
                description: 'Descripción',
                store_name: 'Nombre de la Tienda',
                store_id: 'ID de la tienda',
                merchant_name: 'Nombre del comerciante',
                merchant_id: 'ID del comerciante',
                department_name: 'Nombre del departamento',
                department_id: 'ID del departamento',
                signature_key: 'Clave de firma',
                secret_key: 'Clave secreta',
                user_name: 'Nombre de usuario',
                password: 'Contraseña',
                data: 'Fecha',
                category: 'Categoría',
                url: 'URL',
                acquirerId: 'ID del adquiriente',
                firstName: 'Nombre',
                lastName: 'Apellidos',
                houseName: 'Nombre de la casa',
                postcode: 'Código postal',
                donationProviderType: 'Tipo de proveedor de donación',
                isGiftAid: 'Es ayuda para donativos',
                donationStoreId: 'ID de Tienda de donación',
                donationMerchantNumber: 'Número de donación de comerciante',
                clientID: 'ID de cliente',
                clientSecret: 'Cliente secreto',
                terminalID: 'ID de terminal',
                enableCardRefunds: 'Permitir reembolsos de tarjeta',
                enableCardVerification: 'Permitir verificación de tarjeta',
                enableCharity: 'Permitir beneficencia',
                mobileMerchantId: 'Id. de comerciante móvil',
                mobileMerchantPassword: 'Contraseña de comerciante móvil',
            },
            label: {
                name: 'Nombre',
                type: 'Tipo',
                firstName: 'Nombre',
                lastName: 'Apellidos',
                houseName: 'Nombre de la casa',
                postcode: 'Código postal',
                donationProviderType: 'Tipo de proveedor de donación',
                isGiftAid: 'Es ayuda para donativos',
                donationStoreId: 'ID de Tienda de donación',
                donationMerchantNumber: 'Número de donación de comerciante',
                code: 'Código',
                description: 'Descripción',
                store_name: 'Nombre de la Tienda',
                store_id: 'ID de la tienda',
                merchant_name: 'Nombre del comerciante',
                merchant_id: 'ID del comerciante',
                department_name: 'Nombre del departamento',
                department_id: 'ID del departamento',
                signature_key: 'Clave de firma',
                secret_key: 'Clave secreta',
                user_name: 'Nombre de usuario',
                password: 'Contraseña',
                data: 'Fecha',
                action_urls: 'URLs de acción',
                category: 'Categoría',
                url: 'URL',
                acquirerId: 'ID del adquiriente',
                clientID: 'ID de cliente',
                clientSecret: 'Secreto de cliente',
                terminalID: 'ID de terminal',
                enableCardRefunds: 'Permitir reembolsos de tarjeta',
                enableCardVerification: 'Permitir verificación de tarjeta',
                enableCharity: 'Permitir caridad',
                mobileMerchantId: 'ID del comerciante móvil',
                mobileMerchantPassword: 'Contraseña de comerciante móvil',
                enableIncrementalAuthorizations: 'Habilitar Autorizaciones Incrementales',
            },
            errors: {
                common: 'Algo ha fallado, vuelva a intentarlo.',
                name: {
                    valid: 'Introduzca un nombre válido',
                },
                code: {
                    valid: 'Introduzca un código válido',
                },
                url: {
                    valid: 'La URL debe ser una URL válida',
                },
                DatatransSupportCards: {
                    valid: 'Por favor ingrese un valor válido para DatatransSupportCards',
                },
            },
        },
    },
    RFIDCards: {
        title: 'Tarjetas RFID: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Tarjetas RFID',
        placeholder: {
            name: 'Nombre del conductor/correo electrónico/Organización',
            manufacturer: 'Fabricante',
            part_id: 'ID de la pieza',
            public_card_id: 'ID de tarjeta pública',
            status: 'Seleccionar estado',
            mifare_uid: 'UID Mifare',
        },
        label: {
            name: 'Asignado a',
            email_vehicle: 'Cuenta asociada',
            manufacturer: 'Fabricante',
            part_id: 'ID de la pieza',
            public_card_id: 'ID de tarjeta pública',
            private_card_id: 'ID de tarjeta privada',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            delete: 'Eliminar',
            deAllocate: 'Eliminar asociación',
            view: 'Ver detalle',
            allocateCardToOrganisation: 'Asignar tarjetas en bloque a organización',
            mifare_uid: 'UID MIFARE',
            reinstate: 'Reactivar tarjeta',
            card_type: 'Tipo de tarjeta',
            removeBulkAssociation: 'Eliminar Asociación de tarjetas RFID en bloque',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Añadir',
            addBulk: 'Añadir tarjetas en bloque para su fabricación',
            assing: 'Asignar tarjetas RFID',
            allocateRFIDCard: 'Asignar tarjeta RFID',
            import: 'Importar archivo de fabricación',
            export: 'Exportar archivo de fabricación',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablecer',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            getCredentials: 'Obtener credenciales',
            delete: 'Eliminar',
            deAllocate: 'Eliminar asociación',
            view: 'Ver detalle',
            reinstate: 'Reactivar tarjeta',
            forceCPOUpdate: 'Forzar actualización de CPO',
        },
        errors: {
            export: {
                notSeletedCards: 'Seleccione tarjetas en espera de exportación',
            },
        },
        message: {
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            deAllocateConfirmMesage:
                '¿Está seguro de que desea eliminar la asociación de la tarjeta RFID de una cuenta?',
            reinstateConfirmMessage: '¿Está seguro/a de que desea reactivar la tarjeta RFID?',
            forceCPOUpdateConfirmMessage: '¿Está seguro de que desea forzar la actualización del token en el sistema?',
        },
        insert: {
            header: 'Administrar tarjetas RFID',
            placeholder: {
                manufacturer: 'Nombre del fabricante',
                part_id: 'ID de la pieza',
                public_card_id: 'ID de tarjeta pública',
                private_card_id: 'ID de tarjeta privada',
                mifare_uid: 'UID Mifare',
                card_type: 'Tipo de tarjeta',
            },
            label: {
                manufacturer: 'Fabricante',
                part_id: 'ID de la pieza',
                public_card_id: 'ID de tarjeta pública',
                private_card_id: 'ID de tarjeta privada',
                mifare_uid: 'UID Mifare',
                card_type: 'Tipo de tarjeta',
            },
            errors: {
                common: 'Algo ha fallado, vuelva a intentarlo.',
                name: {
                    valid: 'Introduzca un nombre válido',
                },
                code: {
                    valid: 'Introduzca un código válido',
                },
                url: {
                    valid: 'La URL debe ser una URL válida',
                },
            },
        },
        bulkCards: {
            header: 'Añadir tarjeta en bloque',
            placeholder: {
                manufacturer: 'Nombre del fabricante',
                part_id: 'ID de la pieza',
                no_of_cards: '100 tarjetas',
                cardType: 'Seleccionar tipo de tarjeta',
            },
            label: {
                manufacturer: 'Nombre del fabricante',
                part_id: 'ID de la pieza',
                no_of_cards: 'N.º de tarjetas',
                cardType: 'Tipo de tarjeta',
            },
            button: {
                yes: 'Crear tarjetas',
                no: 'Cancelar',
            },
            errors: {
                no_of_cards: {
                    min: 'El n.º de tarjetas no puede ser inferior a 1',
                },
            },
        },
        assignCards: {
            header: 'Asignar tarjetas RFID',
            header2: 'Ha seleccionado X tarjetas.',
            selectedCard: 'Ha seleccionado 1 tarjeta.',
            placeholder: {
                manufacturer: 'Nombre del fabricante',
                part_id: 'ID de la pieza',
                no_of_cards: '100 tarjetas',
            },
            label: {
                driver: 'Conductor',
                organisation: 'Organización',
                no_of_cards: 'N.º de tarjetas',
            },
            button: {
                yes: 'Asignar',
                no: 'Cancelar',
            },
            form: {
                type: {
                    driver: 'Conductor',
                    organisation: 'Organización',
                },
                driver: 'Conductor',
                organisation: 'Organización',
                placeholder: {
                    driver: 'Seleccionar conductor',
                    organisation: 'Seleccionar organización',
                },
            },
            errors: {
                notSeletedCards: 'Seleccione tarjetas disponibles',
            },
        },
        disableCards: {
            header: 'Deshabilitar',
            header2: '¿Está seguro/a de que desea deshabilitarlo?',
            placeholder: {
                comment: 'Introducir comentario',
            },
            label: {
                comment: 'Comentario',
            },
            button: {
                yes: 'Sí',
                no: 'No',
            },
        },
        allocateCards: {
            header: 'Asignar tarjetas RFID',
            placeholder: {
                file: 'Seleccionar archivo CSV',
                selectOrganisation: 'Seleccionar organización',
            },
            label: {
                file: 'Archivo CSV',
                organisation: 'Organización',
                mifareUID: 'UID Mifare',
                publicCardID: 'ID de tarjeta pública',
                clickHere: 'Haga clic aquí',
                downloadTemplate: 'para descargar el modelo',
            },
            button: {
                allocate: 'Asignar',
                cancel: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: 'Se permite cargar un archivo con la extensión ".csv".',
                },
            },
        },
        removeAssociation: {
            header: 'Eliminar Asociación de tarjetas RFID en bloque',
            placeholder: {
                file: 'Seleccionar archivo CSV',
            },
            label: {
                file: 'Archivo CSV',
                clickHere: 'Haga clic aquí',
                downloadTemplate: 'para descargar el modelo',
            },
            button: {
                save: 'Guardar',
                cancel: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: 'Se permite cargar un archivo con la extensión ".csv".',
                },
                maxRFIDRecordsReached:
                    'El archivo CSV que ha subido ha alcanzado el número máximo de 10 000 registros públicos de tarjeta pública RFID, reduzca los registros de ID de tarjeta pública RFID en el archivo CSV.',
            },
        },
        importCards: {
            header: 'Importar tarjetas RFID',
            placeholder: {
                file: 'Seleccionar archivo CSV',
            },
            label: {
                file: 'Archivo CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: 'Se permite cargar un archivo con la extensión ".csv".',
                },
            },
        },
        importCardsDetails: {
            header: 'Detalles de importación de tarjetas RFID',
            label: {
                unSuccessfullImport: 'Las siguientes tarjetas no se pueden importar',
                successfullImport: 'Las siguientes tarjetas se han importado correctamente',
                failerReason: 'Motivo del fallo',
                publicCardId: 'ID de tarjeta pública',
            },
            message: {
                defualtErrorMessage: 'Hay un problema al importar las siguientes tarjetas.',
            },
        },
        rfidDetails: {
            label: {
                event_date: 'Fecha de evento',
                chargeLocation: 'Ubicación de carga',
                charge_station_name: 'Nombre de la estación',
                response_status: 'Estado de respuesta',
            },
        },
    },
    referralPromotion: {
        title: 'Promoción de recomendación: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Promociones de recomendaciones',
        manageReferralPromotion: 'Administrar promoción de recomendación',
        label: {
            name: 'Nombre',
            code: 'Código',
            minCharge: 'Carga mín.',
            maxLimit: 'Límite máx.',
            maxRefreeLimit: 'Límite máx. de personas recomendadas',
            createdDate: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            disabled: 'Deshabilitado',
            enabled: 'Permitido',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            promotionCode: 'Código de promoción',
            description: 'Descripción',
            maxReferralLimit: 'Límite máximo de recomendaciones',
            minChargeValue: 'Valor mínimo de carga',
            refereeBonus: 'Bono de la persona recomendada',
            referrerBonus: 'Bono de la persona que recomienda',
        },
        button: {
            search: 'Buscar',
            back: 'Atrás',
            add: 'Añadir',
            reset: 'Restablecer',
            edit: 'Editar',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            save: 'Guardar',
            cancel: 'Cancelar',
            action: 'Acción',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
        },
        placeholder: {
            name: 'Nombre',
            code: 'Código',
            selectPromotion: 'Seleccionar promoción',
            selectStatus: 'Seleccionar estado',
            promotionCode: 'Código de promoción',
            description: 'Descripción',
            maxReferralLimit: 'Límite máximo de recomendaciones',
            minChargeValue: 'Valor mínimo de carga',
            refereeBonus: 'Bono de la persona recomendada',
            referrerBonus: 'Bono de la persona que recomienda',
        },
        errors: {
            name: {
                valid: 'Introduzca un nombre de promoción válido',
            },
            promotionCode: {
                valid: 'Introduzca un código de promoción válido',
            },
            maxReferralLimit: {
                moreThan: 'El límite máximo de recomendación debe ser mayor a cero',
            },
            referrerBonus: {
                max: 'El valor del Bono de Referente no puede ser mayor que ##MAX_REFERRAL_BONUS##',
            },
            refereeBonus: {
                max: 'El valor del Bono de Referido no puede ser mayor que ##MAX_REFERRAL_BONUS##',
            },
        },
    },
    termsConditions: {
        title: 'Términos y condiciones: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Términos y condiciones',
        manageTermsConditions: 'Administrar términos y condiciones',
        label: {
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            name: 'Nombre',
            description: 'Descripción',
            apply_to: 'Aplicar a',
            mandatory_for_user: 'Obligatorio para el usuario',
            status: 'Estado',
            delete: 'Eliminar',
            content: 'Contenido de la política',
            yes: 'Sí',
            no: 'No',
            draft: 'Borrador',
            published: 'Publicado',
        },
        placeholder: {
            name: 'Nombre',
            description: 'Descripción',
            select: {
                apply_to: 'Aplicar a',
                status: 'Seleccionar estado',
            },
        },
        columns: {
            name: 'Nombre',
            description: 'Descripción',
            applyto: 'Aplicar a',
            mandatory_for_user: 'Obligatorio',
            status: 'Estado',
            action: 'Acción',
            modified_date: 'Modificado el',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            edit: 'Editar',
            add: 'Añadir',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
        },
        errors: {
            name: {
                valid: 'Introduzca un nombre válido',
            },
            invalidFormat: 'Cargue un formato de imagen válido',
            common: 'Algo ha fallado, vuelva a intentarlo.',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
        },
    },
    rewardPromotion: {
        title: 'Promociones de recompensas: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Promociones de recompensa IV',
        manageRewardPromotion: 'Administrar promoción de recompensa IV',
        label: {
            name: 'Nombre',
            code: 'Código',
            valuesPerkwh: 'Valores por kWh',
            monetoryValue: 'Valor monetario',
            redemptionBlock: 'Bloque de rescate',
            createdDate: 'Fecha de creación',
            status: 'Estado',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            action: 'Acción',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            promotionCode: 'Código de promoción',
            description: 'Descripción',
            expired: 'Caducada',
            locationApplicable: 'Ubicación de carga aplicable',
            voltsPerkwh: 'Volts por kWh',
            confirmation: 'Confirmación',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Añadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            uncheckConfirmMesage:
                'Al marcar esta casilla, se eliminarán todas las ubicaciones de carga asociadas a esta promoción. ¿Está seguro/a de que desea eliminarlo?',
        },
        placeholder: {
            name: 'Nombre',
            code: 'Código',
            selectPromotion: 'Seleccionar promoción',
            selectStatus: 'Seleccionar estado',
            locationApplicable: 'Ubicación de carga aplicable',
            voltsPerkwh: 'Volts por kWh',
        },
        errors: {
            name: {
                valid: 'Introduzca un nombre de promoción válido',
            },
            promotionCode: {
                valid: 'Introduzca un código de promoción válido',
            },
            monetoryValue: {
                moreThan: 'El valor monetario debe ser superior a cero',
                lessThan: 'El valor monetario debe ser menor o igual a 99999,99',
                typeError: 'Introduzca un valor monetario válido',
            },
            redemptionPointBlock: {
                moreThan: 'El bloque de rescate debe ser superior a cero',
            },
            valuePerKwh: {
                moreThan: 'El valor debe ser superior a cero',
            },
        },
    },
    amenitys: {
        title: 'Servicios: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Servicios',
        manageamenitys: 'Administrar servicios',
        chargeStationsList: 'Estaciones de carga',
        chargeLocation: 'Ubicaciones de carga',
        amenityTranslationNote:
            'Introduzca los detalles del servicio para administradores usuarios/conductores en el idioma correspondiente de la región. Cuando no se han introducido detalles para un idioma específico, el sistema mostrará los detalles de forma predeterminada.',
        label: {
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            name: 'Nombre',
            imageUpload: 'Icono (34 X 34)',
            language: 'Idioma',
            image: 'Icono',
            description: 'Descripción',
            default_search: 'Búsqueda por defecto',
            status: 'Estado',
            delete: 'Eliminar',
            csvFile: 'Archivo CSV',
            importAmenityHeader: 'Importar servicios',
            chargeLocation: {
                name: 'Nombre',
                type: 'Tipo',
                address: 'Dirección',
                city: 'Ciudad',
                postal_code: 'Código postal',
                modifiedDate: 'Fecha de modificación',
                action: 'Acción',
            },
            charge_station_name: 'Charge_Station_Name',
            charge_point: 'Charge_Point',
            charge_location_name: 'Charge_Location_Name',
            latitude: 'Latitud',
            longitude: 'Longitud',
            location_address: 'Location_Address',
            amenities: 'Servicios',
            amenity_type: 'Tipo de servicio',
        },
        placeholder: {
            name: 'Nombre',
            description: 'Descripción',
            file: 'Seleccionar archivo CSV',
            select: {
                status: 'Seleccionar estado',
                amenity_type: 'Seleccionar tipo',
            },
        },
        columns: {
            name: 'Nombre',
            description: 'Descripción',
            status: 'Estado',
            action: 'Acción',
            amenity_type: 'Tipo',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            edit: 'Editar',
            add: 'Añadir',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            disable: 'Deshabilitar',
            enable: 'Permitir',
            import: 'Importar',
        },
        errors: {
            common: 'Algo ha fallado, vuelva a intentarlo.',
            name: {
                valid: 'Introduzca un nombre válido.',
            },
            image: {
                fileType: 'Se pueden subir archivos con las extensiones ".jpg", ".png", ".svg", ".jpeg".',
                dimensions: 'El icono debe tener unas dimensiones de 34 X 34',
                required: 'El icono es un campo necesario',
            },
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
        },
    },
    vehicle: {
        title: 'Vehículo: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Vehículos',
        columns: {
            name: 'Nombre',
            registerNo: 'N.º de registro',
            make: 'Marca',
            model: 'Modelo',
            chargeType: 'Tipo de carga',
            batteryCapacity: 'Capacidad de la batería',
            consumption: 'Consumo',
        },
        placeholder: {
            nameEmail: 'Nombre/correo electrónico',
            makeModelRegistrationNo: 'Marca/Modelo/N.º de registro',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
        },
    },
    incompleteSessions: {
        title: 'Sesiones incompletas: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Sesiones incompletas',
        placeholder: {
            nameOrEmail: 'Nombre/correo electrónico',
            locationOrStation: 'Ubicación/estación',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            status: 'Seleccionar estado',
            comment: 'Introduzca sus comentarios',
        },
        label: {
            invalid: 'Inválido',
            generateCDR: 'Generar CDR',
            totalEnergy: 'Energía total',
            totalCost: 'Coste total',
            comment: 'Introduzca sus comentarios',
            cancelCDR: 'Cancelar CDR',
        },
        columns: {
            name: 'Nombre',
            location: 'Ubicación',
            sessionId: 'ID de sesión',
            startDate: 'Fecha de inicio',
            modifiedDate: 'Fecha de modificación',
            time: 'Tiempo',
            energy: 'Energía </br> (kWh)',
            cost: 'Coste',
            status: 'Estado',
            action: 'Acción',
        },
        button: {
            action: 'Acción',
            generateCDR: 'Generar CDR',
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Guardar',
            cancel: 'Cancelar',
            yes: 'Sí',
            no: 'No',
            cancelCDR: 'Cancelar CDR',
        },
        error: {
            max: 'Se permite un máximo de 250 caracteres',
        },
        message: {
            cancelCDRMessage: '¿Está seguro/a de que desea cancelar la sesión?',
            cancelBulkCDRMessage: '¿Está seguro/a de que desea cancelar la sesión de los registros seleccionados?',
            selectCDR: 'Seleccione sesiones incompletas',
        },
    },
    ocpiSessions: {
        title: 'Sesiones OCPI: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Sesiones',
        placeholder: {
            nameOrEmail: 'Nombre/correo electrónico',
            locationOrStation: 'Ubicación/estación',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            status: 'Seleccionar estado',
            comment: 'Introduzca sus comentarios',
        },
        columns: {
            name: 'Nombre',
            location: 'Ubicación',
            sessionId: 'ID de sesión',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            time: 'Tiempo',
            energy: 'Energía </br> (kWh)',
            cost: 'Coste',
            status: 'Estado',
            action: 'Acción',
            vehicleNumber: 'Número de vehículo',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            complete: 'Completo',
        },
        label: {
            complete: 'Completo',
            completeSessions: 'Sesiones de carga completas',
        },
        message: {
            completeConfirmMessage: '¿Le gustaría completar la sesión de carga?',
            stopBulkSessionsMessage: '¿Le gustaría completar las sesiones de carga seleccionadas?',
            selectSession: 'Seleccione las sesiones de carga',
        },
    },
    organisation: {
        title: 'Administrar organización: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Organización',
        manageOrganisation: 'Administrar organización',
        label: {
            name: 'Nombre',
            description: 'Descripción',
            address: 'Dirección',
            city: 'Ciudad',
            county: 'Condado',
            postal_code: 'Código postal',
            contact_person: 'Persona de contacto',
            email: 'Correo electrónico',
            phone_number: 'N.º de teléfono',
            payment_mode: 'Forma de pago',
            payment_schedule: 'Calendario de pagos',
            user_group_ids: 'Grupos de usuario',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            amount: 'Límite de crédito',
            po_number: 'Número de PO',
            finance_account_number: 'Número de cuenta financiera',
            account_contact_email: 'Correo electrónico de contacto de cuenta',
            remaining_credit: 'Crédito restante (%)',
            remoteChargePassword: 'Contraseña para iniciar carga remota',
            is_deleted: 'Se ha eliminado',
            yes: 'Sí',
            deleted: 'Eliminado',
            dailySpendLimit: 'Límite de gasto diario',
            weeklySpendLimit: 'Límite de gasto semanal',
            monthlySpendLimit: 'Límite de gasto mes natural',
            defaultSpendLimitGroup: 'Grupo de límite de gasto por defecto',
            updateSpendLimitAssociation: 'Asociación de grupo de límite de gasto',
            promotionUpdate: 'Actualización de la promoción',
            currentPromotion: 'Promoción actual',
            newPromotion: 'Nueva promoción',
        },
        placeholder: {
            name: 'Nombre',
            name_or_email_or_contact_person: 'Nombre/Persona de contacto/Correo electrónico',
            description: 'Descripción',
            address: 'Dirección',
            city: 'Ciudad',
            county: 'Provincia',
            postal_code: 'Código postal',
            contact_person: 'Persona de contacto',
            email: 'Correo electrónico',
            phone_number: 'N.º de teléfono',
            select: {
                status: 'Seleccionar estado',
                payment_mode: 'Seleccionar modo de pago',
                payment_schedule: 'Seleccionar calendario de pagos',
                user_group_ids: 'Seleccionar grupos de usuario',
            },
            amount: 'Límite de crédito',
            po_number: 'Número de PO',
            finance_account_number: 'Número de cuenta financiera',
            remaining_credit: 'Crédito restante (%)',
            remoteChargePassword: 'Contraseña para iniciar carga remota',
            enableSpendLimit: 'Permitir límite de gasto',
            defaultSpendLimitGroup: 'Seleccionar grupo de límite de gasto por defecto',
            selectCurrentPromotion: 'Seleccionar promoción actual',
            selectNewPromotion: 'Seleccionar nueva promoción',
        },
        columns: {
            name: 'Nombre',
            contact_Person: 'Persona de contacto',
            email: 'Correo electrónico',
            payment_mode: 'Forma de pago',
            payment_schedule: 'Calendario de pagos',
            created_date: 'Creado el',
            status: 'Estado',
            action: 'Acción',
            remote_charge_password: 'Contraseña para iniciar carga remota',
            promotion: 'Promoción',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            edit: 'Editar',
            add: 'Añadir',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            permission: 'Permiso de API',
            assignSpendLimitGroup: 'Asignar límite de gasto por defecto',
        },
        errors: {
            name: {
                valid: 'Introduzca un nombre válido',
            },
            contact_person: {
                valid: 'Introduzca una persona de contacto válida',
            },
            email: {
                required: 'Introduzca la dirección de correo electrónico',
                email: 'Introduzca una dirección de correo electrónico válida',
            },
            phoneNo: {
                required: 'Introduzca un número de teléfono',
                match: 'Introduzca un número de teléfono válido',
            },
            amount: {
                moreThan: 'La cantidad debe ser superior a 0',
                maxcredit: 'Se ha alcanzado el límite máximo de crédito de la cuenta',
            },
            po_number: {
                valid: 'Introduzca un número de PO válido',
            },
            finance_account_number: {
                valid: 'Introduzca un número válido de cuenta financiera',
            },
            account_contact_email: {
                required: 'Introduzca al menos una dirección de correo electrónico',
                maxLimit: 'Límite máximo alcanzado de correos electrónicos de contacto de cuenta',
            },
            remaining_credit: {
                match: 'Introduzca un crédito restante válido',
                maxCredit: 'El valor máximo de crédito restante no deberá ser superior a 100',
                minCredit: 'El valor máximo de crédito restante no deberá ser menor de 0',
            },
            value: {
                moreThan: 'El valor debe ser superior a 0',
                lessThan: 'El valor debe ser menor o igual a 5000',
                number: 'El valor debe ser un número',
                lessThanWeekly: 'El valor debe ser menor o igual al límite de gasto semanal',
                lessThanMonthly: 'El valor debe ser menor o igual al límite de gasto mensual',
            },
            spend_limit: {
                moreThan: 'El límite de gasto semanal debe ser superior al límite de gasto diario',
                lessThan: 'El límite de gasto diario debe ser inferior al límite de gasto semanal',
            },
            address: 'debe tener al menos 10 caracteres',
            addressValid: 'Introduzca una dirección válida',
            user_group: {
                required: 'Seleccione al menos un grupo de usuario',
            },
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            assignAllDriversToDefaultGroup:
                '¿Le gustaría asignar a todos los conductores de esta organización el grupo de límite de gasto por defecto?',
            updatePromotionConfirmMessage:
                '¿Está seguro/a de que desea actualizar la promoción para las organizaciones seleccionadas?',
            selectOneRecord: 'Seleccione al menos una organización para actualizar la promoción',
            promotionAssignMessage: 'Se asignará la nueva promoción a las siguientes organizaciones:',
        },
        permission: {
            header: 'Permiso de API',
            label: {
                description: 'Descripción',
                action: 'APIs',
            },
        },
    },
    transactionLogs: {
        title: 'Registros de transacciones: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Registros de transacciones',
        placeholder: {
            page: 'Seleccionar página',
            email: 'Dirección de correo electrónico',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            fieldName: 'Nombre del campo',
            content: 'Contenido',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
        },
        label: {
            tableName: 'Nombre de la tabla',
            fieldName: 'Nombre del campo',
            oldValue: 'Valor anterior',
            newValue: 'Valor nuevo',
            user: 'Usuario',
            logDate: 'Fecha del registro',
            action: 'Acción',
            goToPage: 'Ir a página',
        },
    },
    organisationAccountBalance: {
        title: 'Saldo de cuenta de la organización: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Saldo de cuenta de la organización',
        manageUser: 'Administrar saldo de cuenta de la organización',
        columns: {
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito disponible',
            unbilledAmount: 'Importe no facturado',
            name: 'Nombre',
            contact_Person: 'Persona de contacto',
            email: 'Correo electrónico',
            payment_mode: 'Forma de pago',
            payment_schedule: 'Calendario de pagos',
            balance: 'Saldo',
            status: 'Estado',
            action: 'Acción',
            refund: 'Modificar saldo de cuenta',
        },
        placeholder: {
            name: 'Nombre/Persona de contacto/Correo electrónico',
            description: 'Comentario',
            amount: 'Introducir el importe de crédito/débito',
            select: {
                status: 'Seleccionar estado',
                payment_mode: 'Forma de pago',
                payment_schedule: 'Calendario de pagos',
            },
            invoice: 'Seleccionar factura',
        },
        label: {
            description: 'Comentario',
            amount: 'Introducir el importe de crédito/débito',
            payment_settlement: 'Solicitud de modificación de saldo',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            invoice: 'Factura',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Guardar',
            add: 'Añadir',
            edit: 'Editar',
            reset: 'Restablecer',
            action: 'Acción',
            send_for_approval: 'Enviar para aprobación',
            accept: 'Aceptar',
        },
        errors: {
            amount: {
                moreThan: 'La cantidad debe ser superior/inferior a 0',
                maxcredit: 'Se ha alcanzado el límite máximo de crédito de la cuenta',
                maxdebit: 'Se ha alcanzado el límite máximo de débito de la cuenta',
            },
        },
    },
    driverAward: {
        rewardTitle: 'Saldo de recompensas - ##COMPANY_BRAND_NAME## : Carga rápida de VE Reino Unido',
        approvalRequest:
            'Aprobaciones de saldo de recompensas - ##COMPANY_BRAND_NAME##: Carga rápida de VE Reino Unido',
        rewards: 'Saldo de recompensas',
        approvalRequests: 'Aprobaciones de saldo de recompensa',
        label: {
            name: 'Nombre',
            email: 'Correo electrónico',
            iVRewardPromotion: 'Promoción de recompensa IV',
            balance: 'Saldo',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            location: 'Ubicación',
            date: 'Fecha',
            energy: 'Energía (kWh)',
            cost: 'Coste',
            rewardPoint: 'Punto de recompensa',
            rewardSettelemant: 'Pago de recompensa',
            description: 'Descripción',
            credit: 'Crédito',
            debit: 'Débito',
            iVRewardSettelemant: 'Recompensas: pago',
            amount: 'Cantidad',
            request_by: 'Solicitado por',
            request_date: 'Solicitado el',
            review_by: 'Reseñado por',
            review_date: 'Reseñado el',
            review_comment: 'Comentarios del autor de la reseña',
            approvalRequest: 'Solicitud de aprobación',
            enterComments: 'Introduzca sus comentarios',
            transaction_date: 'Fecha de transacción',
            debit_credit: 'Débito/Crédito',
            type: 'Tipo',
            requested_by_comment: 'Solicitado por Comentarios',
            volts: 'Volts',
            commentsFrom: 'Comentarios de',
            approve: 'Aprobar',
            decline: 'Rechazar',
            federatedAccount: 'Tipo de cuenta federada',
        },
        placeholder: {
            nameOrEmail: 'Nombre/correo electrónico',
            selectIVAwardPromotion: 'Seleccionar promoción de recompensa IV',
            selectStatus: 'Seleccionar estado',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            description: 'Descripción',
            volts: 'Volts',
            enterComments: 'Introduzca sus comentarios',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Guardar',
            cancel: 'Cancelar',
            decline: 'Rechazar',
            approve: 'Aprobar',
            send_for_approval: 'Enviar para aprobación',
        },
        errors: {
            type: {
                required: 'Abonar o cargar la liquidación',
            },
            volts: {
                typeError: 'Introduzca Volts válidos',
                moreThan: 'La cantidad de Volts debe ser superior/inferior a 0',
            },
            status: {
                selectApprovalOrReject: 'Abobar/rechazar esta solicitud.',
            },
        },
    },
    organisationdashboard: {
        title: 'Panel de control de la organización: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Panel de control de la organización',
        dashboard: 'Panel de control',
        label: {
            filter: 'Filtro',
            organisation: 'Organización',
            selectOrganisations: 'Seleccionar organizaciones',
            dateRange: 'Rango de fechas',
            driverGroup: 'Grupos de conductor',
            drivers: 'Conductor/vehículo',
            selectDriver: 'Seleccionar conductor/vehículo',
            selectDriverGroup: 'Seleccionar grupos de conductor',
            month: 'Mes',
            year: 'Año',
            day: 'Día',
            week: 'Semana',
            userSessionTitle: 'Sesiones del conductor',
            userSessions: 'Sesiones del conductor',
            totalIncomeTitle: 'Suma de ingresos',
            income: 'Ingresos',
            energy: 'Energía',
            energyTitle: 'Total de energía (kWh)',
            selectAll: 'Seleccionar todos',
            totalRFIDCards: 'Total tarjetas RFID',
            available: 'Disponible',
            allocated: 'Asignado',
            duplicate: 'Duplicado',
            disabled: 'Deshabilitado',
            rfid: 'RFID',
            totalDriverAccounts: 'Total de cuentas de conductor',
            driver: 'Conductores',
            enabled: 'Permitido',
            pending: 'Pendiente',
            deleted: 'Eliminado',
            topTenDriverVehicles: 'Top uso 10 conductores/vehículos',
            driverAccount: 'Conductor',
            vehicle: 'Vehículo',
            driverName: 'Nombre del conductor',
            vehicleNumber: 'Número de vehículo',
            kwhUsage: 'Uso kWh',
            dateRangeLabel: 'Rango de fechas:',
            both: 'Ambos',
            nameorvehicleno: 'Nombre/n.º de vehículo',
            type: 'Tipo',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Borrar',
            syncData: 'Sincronizar datos',
            search: 'Buscar',
            reset: 'Restablecer',
        },
    },
    organisationtransactions: {
        headerTitle: 'Transacciones de la Organización - ##COMPANY_BRAND_NAME## : Carga rápida de VE Reino Unido',
        invoiceHeader: 'Detalle de la factura - ##COMPANY_BRAND_NAME## : Carga rápida de VE Reino Unido',
        invoiceTitle: 'Detalle de la factura',
        title: 'Transacciones de la organización',
        transaction: 'Transacción',
        columns: {
            location: 'Ubicación',
            date: 'Fecha',
            time: 'Tiempo',
            cost: 'Coste',
            energy: 'Energía',
            action: 'Acción',
            remark: 'Observaciones',
            amount: 'Cantidad',
            closing: 'Cerrando',
            transaction: 'ID de transacción',
            name: 'Nombre',
            credit: 'Crédito',
            debit: 'Débito',
            vehicleNumber: 'Número de vehículo',
            invoiceNumber: 'Número de factura',
            comment: 'Comentario',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        form: {
            charge: 'Cargando',
            payment: 'Pago',
            month: 'Mes',
        },
        label: {
            exportAll: 'Exportar todo',
            amount: 'Cantidad',
            driverName: 'N.º de conductor/vehículo',
            station: 'Estación',
            kwh: 'kWh',
            price_per_kwh: 'Precio/kWh',
            net_value: 'Valor neto',
            vat_rate: 'Tasa de IVA',
            gross_value: 'Valor Bruto',
            totalBeforeVAT: 'Total antes de IVA',
            VatAt: 'IVA de',
            VatRate: 'Tasa de IVA:',
            totalNetAmount: 'Importe total neto',
            subTotal: 'Subtotal',
            adjustedAmount: 'Importe ajustado',
            grandTotal: 'Total',
            totalFee: 'Tarifa total',
            invoiceNumber: 'Número de factura',
            invoiceDate: 'Fecha de factura',
            transaction: 'ID de transacción',
            name: 'Nombre',
            date: 'Fecha',
            publicCardId: 'ID de tarjeta pública',
            stationId: 'ID de estación',
            transactionStartDate: 'Fecha de inicio de transacción',
            transactionEndDate: 'Fecha de finalización de transacción',
            stationAddress: 'Dirección de la estación',
            driverAccountId: 'ID de cuenta de conductor',
            vat_amount: 'Importe de IVA',
            stationName: 'Nombre de la estación',
            status: 'Estado',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Atrás',
            export: 'Exportar',
        },
        placeholder: {
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            startDateFrom: 'Fecha de inicio, desde',
            startDateTo: 'Fecha de inicio, hasta',
            select: {
                organisation: 'Seleccionar organización',
                invoice: 'Seleccionar número de factura',
            },
        },
        message: {
            noDataToExport: 'No hay datos que exportar.',
            organisation: {
                required: 'Seleccione una organización',
            },
            selectRecordToExport: 'Seleccione los registros a exportar.',
        },
    },
    driverVehicleAccount: {
        title: 'Cuentas de conductor/vehículo: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Cuentas de conductor/vehículo',
        managedriver: 'Administrar conductor/vehículo',
        importHeader: 'Subir nuevas cuentas con tarjetas RFID',
        importUpdateStatusHeader: 'Habilitar/Deshabilitar cuentas',
        importUpdateSpendGroupAssociation: 'Actualizar Asociación de grupo de límite de gasto',
        placeholder: {
            name: 'Nombre/Correo electrónico/N.º de vehículo',
            rfidCardNo: 'N.º de tarjeta RFID',
            driverGroups: 'Seleccionar grupos de conductor',
            status: 'Seleccionar estado',
            first_name: 'Nombre',
            last_name: 'Apellidos',
            email: 'Dirección de correo electrónico',
            vehicle_no: 'N.º de vehículo',
            driverGroup: 'Seleccionar grupos de conductor',
            accountType: 'Seleccionar tipo de cuenta',
            publicRFIDCardNo: 'Introducir n.º de tarjeta RFID',
            languagePreference: 'Preferencia de idioma',
        },
        label: {
            name: 'Nombre',
            email: 'Correo electrónico',
            vehicleNo: 'N.º de vehículo',
            group: 'Grupo',
            createdDate: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            cancelled: 'Cancelado',
            deleted: 'Eliminado',
            delete: 'Eliminar',
            first_name: 'Nombre',
            last_name: 'Apellidos',
            vehicle_no: 'N.º de vehículo',
            driverGroup: 'Grupos de conductor',
            accountType: 'Tipo de cuenta',
            assignRFIDCard: 'Asignar tarjeta RFID',
            rfidCard: 'Tarjeta RFID',
            publicRFIDCardNo: 'Introducir n.º de tarjeta RFID pública',
            assign: 'Asignar',
            allocatedRFIDCards: 'Tarjetas RFID asignadas',
            file: 'Archivo CSV',
            clickHere: 'Haga clic aquí',
            downloadTemplate: 'para descargar el modelo',
            errosInImportedFile: 'Errores',
            driverVehicleNo: 'N.º de conductor/vehículo',
            driverVehicleDetails: 'Detalles de conductor/vehículo',
            error: 'Error',
            pending: 'Pendiente',
            card_allocated: 'Tarjeta RFID Asignada',
            driver: 'Conductor (cuenta basada en Aplicación de flota)',
            vehicle: 'Vehículo (cuenta basada en RFID)',
            note: 'Nota:',
            accountSetupNote:
                'El titular de la cuenta deberá completar la configuración de la cuenta en 24 horas a través de la aplicación de flota de ##COMPANY_BRAND_NAME## usando la contraseña temporal proporcionada por correo electrónico.',
        },
        button: {
            import: 'Importar',
            add: 'Añadir',
            search: 'Buscar',
            reset: 'Restablecer',
            edit: 'Editar',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            assignRFIDCard: 'Asignar tarjeta RFID',
            assign: 'Asignar',
            action: 'Acción',
            done: 'Realizado',
            sendEmail: 'Enviar correo electrónico',
            enableDisableAccounts: 'Habilitar/Deshabilitar cuentas',
            export: 'Exportar',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            sendMailConfirmMessage: '¿Está seguro/a de que desea enviar el correo electrónico?',
            mailSentSuccessMessage: 'Correo electrónico enviado satisfactoriamente.',
        },
        errors: {
            invalidEmail: 'Introduzca una dirección de correo electrónico válida.',
            invalidFirstName: 'Introduzca un nombre válido.',
            invalidLastName: 'Introduzca un apellido válido.',
            invalidVehicleNo: 'Introduzca un n.º de vehículo válido.',
            common: 'Algo ha fallado, vuelva a intentarlo.',
        },
        account_type: {
            driver: 'Conductor',
            vehicle: 'Vehículo',
        },
        columns: {
            public_rfid_card_no: 'N.º de tarjeta',
            allocatedBy: 'Asignado por',
            allocatedDate: 'Asignado el',
            status: 'Estado',
        },
    },
    chargingHistory: {
        header: 'Sesiones de carga - ##COMPANY_BRAND_NAME## : Carga rápida de VE Reino Unido',
        title: 'Sesiones de carga',
        label: {
            exportAll: 'Exportar',
            location: 'Ubicación',
            date: 'Fecha',
            milesAdded: 'Millas añadidas',
            time: 'Tiempo',
            cost: 'Coste',
            energy: 'Energía',
            action: 'Acción',
            remark: 'Observaciones',
            name: 'Nombre',
            vehicleNo: 'N.º de vehículo',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Atrás',
        },
        placeholder: {
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            startDateFrom: 'Fecha de inicio, desde',
            startDateTo: 'Fecha de inicio, hasta',
            driver: 'Nombre/Correo electrónico/N.º de vehículo',
            selectDriverGroup: 'Seleccionar grupos conductor/vehículo',
        },
        errors: {
            noDataToExport: 'No hay datos que exportar.',
            selectRecordToExport: 'Seleccione los registros a exportar.',
            common: 'Algo ha fallado, vuelva a intentarlo.',
        },
    },
    paymentHistory: {
        header: 'Historial de pagos - ##COMPANY_BRAND_NAME##: Carga rápida de VE Reino Unido',
        title: 'Historial de pagos',
        invoiceHeader: 'Detalle de la factura - ##COMPANY_BRAND_NAME##: Carga rápida de VE Reino Unido',
        invoiceTitle: 'Detalle de la factura',
        label: {
            remark: 'Observaciones',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Cerrando',
            transaction: 'ID de transacción',
            name: 'Nombre',
            date: 'Fecha',
            amount: 'Cantidad',
            driverName: 'N.º de conductor/vehículo',
            station: 'Estación',
            kwh: 'kWh',
            price_per_kwh: 'Precio/kWh',
            net_value: 'Valor neto',
            vat_rate: 'Tasa de IVA',
            gross_value: 'Valor Bruto',
            totalBeforeVAT: 'Total antes de IVA',
            VatAt: 'IVA de',
            totalFee: 'Tarifa total',
            invoiceNumber: 'Número de factura',
            invoiceDate: 'Fecha de factura',
            publicCardId: 'ID de tarjeta pública',
            stationId: 'ID de estación',
            transactionStartDate: 'Fecha de inicio de transacción',
            transactionEndDate: 'Fecha de finalización de transacción',
            stationAddress: 'Dirección de la estación',
            driverAccountId: 'ID de Cuenta de conductor',
            vat_amount: 'Importe de IVA',
            stationName: 'Nombre de la estación',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        placeholder: {
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            export: 'Exportar',
        },
        errors: {
            noDataToExport: 'No hay datos que exportar.',
            selectRecordToExport: 'Seleccione los registros a exportar.',
        },
    },
    configurations: {
        title: 'Configuraciones: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Configuraciones',
        columns: {
            name: 'Nombre',
            value: 'Valor',
            description: 'Descripción',
            system_type: 'Tipo de sistema',
            modifiedBy: 'Modificado por',
            modifiedDate: 'Fecha de modificación',
            action: 'Acción',
        },
        button: {
            save: 'Guardar',
            cancel: 'Cancelar',
            reset: 'Restablecer',
            search: 'Buscar',
            action: 'Acción',
            edit: 'Editar',
        },
        note: 'ATENCIÓN: Cambiar estos ajustes de configuración afectará significativamente al rendimiento de la plataforma. En caso de duda, póngase en contacto con el administrador del sistema.',
        errors: {
            maxLengthString: 'Introduzca un valor con un máximo de',
            maxLengthStringCharacters: 'caracteres',
            maxLengthNUmberCharacters: 'dígitos',
            valueBetween: 'Introduzca un valor entre',
            valueGraterThen: 'Introduzca un valor igual o superior a',
            valueMention: 'Introduzca un valor en el rango mencionado',
        },
        placeholder: {
            value: 'Introduzca el valor',
            description: 'Introduzca la descripción',
            name: 'Nombre',
            valueSearch: 'Valor',
            descriptionSearch: 'Descripción',
            referenceCode: 'Código de referencia',
            systemType: 'Seleccionar tipo de sistema',
        },
        label: {
            value: 'Valor',
            dataType: 'Tipo de datos',
            description: 'Descripción',
            system: 'SISTEMA',
            driver: 'CONDUCTOR',
            admin: 'ADMINISTRADOR',
            referenceCode: 'Código de referencia',
        },
    },
    rfidRequests: {
        title: 'Solicitudes de tarjetas RFID - ##COMPANY_BRAND_NAME##: Carga rápida de VE Reino Unido',
        header: 'Solicitudes de tarjeta RFID',
        placeholder: {
            nameEmail: 'Nombre/correo electrónico',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            publicCardNo: 'Introduzca un n.º de tarjeta pública',
            enterComments: 'Introduzca sus comentarios',
            status: 'Seleccionar estado',
            publicRFIDCardNo: 'Introducir n.º de tarjeta RFID',
            scanReqQR: 'Escanee el código QR impreso en la carta',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Guardar',
            cancel: 'Cancelar',
            add: 'Añadir',
            done: 'Realizado',
            action: 'Acción',
            assign: 'Asignar',
            downloadPdf: 'Descargar PDF de solicitudes',
            downloadPdfSelected: 'Descargar PDF de las solicitudes seleccionadas',
            downloadPendingApprovedPdf: 'Descargar PDF de todas las solicitudes pendientes y aprobadas',
        },
        columns: {
            name: 'Nombre',
            email: 'Correo electrónico',
            requestedDate: 'Fecha de solicitud',
            noofCardReq: 'N.º de tarjeta solicitada',
            noofCardAllocated: 'N.º de tarjeta asignada',
            requestStatus: 'Estado de la solicitud',
            status: 'Estado',
            driverStatus: 'Estado de conductor',
            action: 'Acción',
            public_rfid_card_no: 'N.º de tarjeta',
            allocatedBy: 'Asignado por',
            allocatedDate: 'Asignado el',
            federated_account_type: 'Tipo de cuenta federada',
        },
        label: {
            reviewRequest: 'Solicitar revisión',
            assignRFID: 'Tarjeta RFID',
            processRFIDRequest: 'Procesar solicitud',
            noofCardRequested: 'N.º de tarjeta solicitada',
            noofCardAllocated: 'N.º de tarjeta asignada',
            approved: 'Aprobar',
            declined: 'Rechazar',
            publicCardNo: 'Introduzca un n.º de tarjeta pública',
            enterComments: 'Introduzca sus comentarios',
            requestStatus: 'Estado de la solicitud',
            assignRFIDCards: 'Asignar tarjetas RFID',
            publicRFIDCardNo: 'Introducir n.º de tarjeta RFID',
            allocatedRFIDCards: 'Tarjetas RFID asignadas',
            address: 'Dirección',
            scanReqQR: 'Escanee el código QR impreso en la carta',
            name: 'Nombre',
            requestId: 'ID de solicitud',
            scanHistory: 'Historial de escaneo',
        },
        message: {
            requestProcessed: 'Solicitud procesada satisfactoriamente',
        },
        errors: {
            approveReject: 'Apruebe/rechace esta solicitud.',
            selectAnyRecord: 'Seleccione al menos un registro para descargar el PDF.',
            reqNumTypeError: 'Introduzca un ID de solicitud válido',
        },
        pdfText: {
            dear: 'Estimado/a',
            instavolt: '##COMPANY_BRAND_NAME##',
            companyNumber: 'Número de empresa',
            line1: 'Gracias por solicitar su tarjeta RFID a través de la aplicación ##COMPANY_BRAND_NAME##, adjuntamos su tarjeta.',
            line2: 'Para activar su tarjeta, siga los pasos siguientes:',
            step1: '1. Inicie sesión en la aplicación',
            step2: '2. En el menú, seleccione "Ajustes"',
            step3: '3. Haga clic en la opción "Mis tarjetas RFID"',
            step4: '4. Haga clic en el botón "Añadir tarjeta RFID"',
            step5: '5. Introduzca el número de tarjeta impreso en la tarjeta y pulse el botón "Continuar"',
            step6: '6. Su tarjeta ya se ha activado y puede usarse para empezar su siguiente sesión de carga',
            line3: '¿Sabía que puede ganar recompensas cada vez que cargue? Recibirá un Volt por cada kWh usado y, cuando haya acumulado suficientes Volts, se pueden canjear y usar para comprar sesiones de recarga en la red.',
            line4: 'Gracias por cargar con nosotros.',
            line5: 'El equipo de ##COMPANY_BRAND_NAME##',
            line6: 'Proporcionamos a Reino Unido una infraestructura de carga de vehículos eléctricos de primera clase',
        },
    },
    RFIDCardFleets: {
        title: 'Tarjetas RFID: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Tarjetas RFID',
        placeholder: {
            name: 'Nombre del conductor/Correo electrónico/N.º de vehículo',
            manufacturer: 'Fabricante',
            public_card_id: 'ID de tarjeta pública',
            status: 'Seleccionar estado',
            mifare_uid: 'UID Mifare',
        },
        label: {
            name: 'Nombre',
            manufacturer: 'Fabricante',
            part_id: 'ID de la pieza',
            public_card_id: 'ID de tarjeta pública',
            private_card_id: 'ID de tarjeta privada',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            delete: 'Eliminar',
            remove: 'Eliminar asociación',
            reinstate: 'Reactivar',
            activated: 'Activado',
            available: 'Disponible',
            duplicate: 'Duplicado',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Añadir',
            assing: 'Asignar tarjeta RFID',
            import: 'Importar archivo',
            save: 'Guardar',
            edit: 'Editar',
            reset: 'Restablecer',
            yes: 'Sí',
            no: 'No',
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            action: 'Acción',
            back: 'Atrás',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            getCredentials: 'Obtener credenciales',
            delete: 'Eliminar',
            remove: 'Eliminar asociación',
            reinstate: 'Reactivar',
            exportAll: 'Exportar todo',
        },
        message: {
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            removeConfirmMesage: '¿Está seguro de que desea eliminar la asociación de la tarjeta RFID de una cuenta?',
            reinstateConfirmMessage: '¿Está seguro/a de que desea reactivar la tarjeta RFID?',
        },
        insert: {
            header: 'Administrar tarjetas RFID',
            placeholder: {
                manufacturer: 'Nombre del fabricante',
                part_id: 'ID de la pieza',
                public_card_id: 'ID de tarjeta pública',
                private_card_id: 'ID de tarjeta privada',
                mifare_uid: 'UID Mifare',
            },
            label: {
                manufacturer: 'Fabricante',
                part_id: 'ID de la pieza',
                public_card_id: 'ID de tarjeta pública',
                private_card_id: 'ID de tarjeta privada',
                mifare_uid: 'UID Mifare',
            },
            errors: {
                common: 'Algo ha fallado, vuelva a intentarlo.',
                name: {
                    valid: 'Introduzca un nombre válido',
                },
                code: {
                    valid: 'Introduzca un código válido',
                },
                url: {
                    valid: 'La URL debe ser una URL válida',
                },
            },
        },
        assignCards: {
            header: 'Asignar tarjeta RFID',
            label: {
                driver: 'Conductor/vehículo',
            },
            button: {
                yes: 'Asignar',
                no: 'Cancelar',
            },
            form: {
                driver: 'Conductor/vehículo',
                placeholder: {
                    driver: 'Seleccionar conductor/vehículo',
                },
            },
        },
        disableCards: {
            header: 'Deshabilitar',
            header2: '¿Está seguro/a de que desea deshabilitarlo?',
            placeholder: {
                comment: 'Introducir comentario',
            },
            label: {
                comment: 'Comentario',
            },
            button: {
                yes: 'Sí',
                no: 'No',
            },
        },
        importCards: {
            header: 'Importar tarjetas RFID',
            placeholder: {
                file: 'Seleccionar archivo CSV',
            },
            label: {
                file: 'Archivo CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancelar',
            },
            errors: {
                common: 'Algo ha fallado, vuelva a intentarlo.',
                file: {
                    fileType: 'Se permite cargar un archivo con la extensión ".csv".',
                },
            },
        },
        importCardsDetails: {
            header: 'Detalles de importación de tarjetas RFID',
            label: {
                unSuccessfullImport: 'Las siguientes tarjetas no se pueden importar',
                successfullImport: 'Las siguientes tarjetas se han importado correctamente',
                failerReason: 'Motivo del fallo',
                publicCardId: 'ID de tarjeta pública',
            },
            message: {
                defualtErrorMessage: 'Hay un problema al importar las siguientes tarjetas.',
            },
        },
    },
    myProfile: {
        title: 'Mi perfil: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Mi perfil',
        subheader: {
            details: 'Datos personales',
            security: 'Seguridad',
            password: 'Contraseña',
        },
        label: {
            firstName: 'Nombre',
            lastName: 'Apellidos',
            email: 'Correo electrónico',
            phoneNo: 'N.º de teléfono',
            currentPassword: 'Contraseña actual',
            newPassword: 'Contraseña nueva',
            confirmPassword: 'Vuelva a confirmar la contraseña',
            mfaAuthentication: 'Autenticación 2FA',
            authentication: 'Autenticación',
            securityCode: 'Código de seguridad',
            languagePreference: 'Preferencia de idioma',
        },
        placeholder: {
            firstName: 'Nombre',
            lastName: 'Apellidos',
            email: 'Correo electrónico',
            phoneNo: 'N.º de teléfono',
            currentPassword: 'Contraseña actual',
            newPassword: 'Contraseña nueva',
            confirmPassword: 'Vuelva a confirmar la contraseña',
            securityCode: 'Código de seguridad',
            languagePreference: 'Preferencia de idioma',
        },
        button: {
            save: 'Guardar',
            cancel: 'Cancelar',
            update: 'Actualizar',
            ok: 'De acuerdo',
        },
        toast: {
            profileSuccess: 'Perfil actualizado satisfactoriamente.',
            profileError: 'El perfil no está actualizado. Vuelva a intentarlo más tarde.',
            passwordChange: 'Contraseña cambiada satisfactoriamente.',
            passwordErr: 'La contraseña no se ha cambiado correctamente. Vuelva a intentarlo más tarde.',
            passwordWrong: 'La contraseña actual es incorrecta.',
            securityStop: 'La Autenticación 2FA de seguridad se ha detenido.',
            error: 'Algo ha fallado. Vuelva a intentarlo más tarde.',
            securitySetupSuccess: 'La Autenticación 2FA se ha configurado satisfactoriamente.',
            securitySetupError: 'La Autenticación 2FA se ha configurado correctamente. Vuelva a intentarlo más tarde.',
            securityCodeInvalid: 'Código de seguridad no válido.',
        },
        errors: {
            securityCode: {
                match: 'Introduzca un código válido',
                inValid: 'Introduzca el código de 6 dígitos',
            },
            password: {
                confirmPasswordMatch: 'La contraseña y la confirmación de contraseña no coinciden.',
            },
        },
    },
    apiCredentials: {
        title: 'Credenciales de la API: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Credenciales de la API',
        button: {
            generate: 'Generar token',
            regenerate: 'Regenerar token',
            yes: 'Sí',
            no: 'No',
        },
        note_no_permission:
            'Usted no tiene derecho de acceso a la API. Póngase en contacto con el administrador de ##COMPANY_BRAND_NAME## para obtener acceso.',
        note_generte_token:
            'Puede generar el token haciendo clic en "Generar token" y puede usar ese token para acceder a la API.',
        note: 'Puede regenerar el token haciendo clic en "Regenerar token" y puede usar ese token para acceder a la API.',
        label: {
            token: 'Token',
            generate: 'Generar token',
            regenerate: 'Regenerar token',
        },
        message: {
            regenerateConfirmMesage:
                '¿Está seguro/a de que desea regenerar el token? <br/> Una vez regenere el token, el viejo token no será válido y usted no podrá acceder a la API con el anterior.',
            generateConfirmMesage: '¿Está seguro/a de que desea generar el token?',
        },
    },
    cookiePolicy: {
        text: 'Este sitio web utiliza cookies para mejorar la experiencia del usuario. Al utilizar nuestro sitio, usted reconoce que ha leído y entiende nuestra',
        action: 'Política de cookies',
        iAccept: 'Acepto',
    },
    paymentconfig: {
        title: 'Pago - ##COMPANY_BRAND_NAME##: Carga rápida de VE Reino Unido',
        header: 'Pago',
        processingNote: 'Espere mientras se procesa su transacción',
        purchaseOrderNote:
            'Tiene un período de facturación de ##PAYMENT_SCHEDULE##. La siguiente fecha de facturación será:',
        description: 'Pago a ##COMPANY_BRAND_NAME##',
        note: 'El proceso en segundo plano se ejecutará todas las semanas para liquidar las facturas pendientes de carga de VE que realicen los conductores/vehículos',
        addReplaceCardNote:
            'Tenga en cuenta que al añadir una tarjeta de pago se cargará en su cuenta en ##CURRENCY_SYMBOL_WITH_VALUE## que se abonará a su saldo de cartera de ##COMPANY_BRAND_NAME##.',
        label: {
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito disponible',
            unbilledAmount: 'Importe no facturado',
            cardTitle: 'Nombre que figura en la tarjeta',
            cardNumber: 'Número de tarjeta',
            expiry: 'Válida hasta',
            note: 'Nota:',
            CSC: 'CVV',
            cardSecurityCode: '(Código de seguridad de la tarjeta)',
            charityDonation: 'Donación a la beneficencia',
            roundUp: 'Redondear',
            topUp: 'Completar',
            expires: 'Válida hasta',
            charity: 'Beneficencia',
        },
        placeholder: {
            cardTitle: 'Nombre que figura en la tarjeta',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CVV',
            topUpAmount: '00,00',
        },
        button: {
            save: 'Guardar',
            edit: 'Editar',
            replace: 'Reemplazar',
            back: 'Atrás',
            payNow: 'Pagar ahora',
        },
        errors: {
            CSC: {
                min: 'Introduzca un código de al menos 3 dígitos.',
            },
            topupAmount: {
                min: 'La cantidad para la beneficencia debe ser superior o igual a 0,1',
            },
            cardNumber: {
                inValid: 'Número de tarjeta no válido',
            },
            commonError: 'Se ha producido un error al procesar su solicitud, vuelva a intentarlo más tarde.',
            transactionFailed: 'Su transacción ha fallado, vuelva a intentarlo.',
        },
        message: {
            cardSaved: 'Datos de tarjeta guardados satisfactoriamente',
        },
    },
    refundRequest: {
        title: 'Aprobaciones de retirada - ##COMPANY_BRAND_NAME## : Carga rápida de VE Reino Unido',
        header: 'Aprobaciones de retirada',
        accountInfoNote: 'Información de la cuenta introducida para efectuar la retirada:',
        completeConfirmNote:
            'Complete esta solicitud de retirada solo si ha ingresado en la cuenta bancaria del conductor el valor señalado. ¿Desea continuar?',
        bulkCompleteConfirmNote:
            'Complete estas solicitudes de retirada solo si ha ingresado en la cuenta bancaria del conductor el valor señalado. ¿Desea continuar?',
        declineConfirmNote:
            'Asegúrese de haber indicado un motivo apropiado para rechazar la solicitud, ya que esta información se pasa al cliente.  ¿Desea continuar?',
        bulkDeclineConfirmNote:
            'Asegúrese de haber indicado un motivo apropiado para rechazar las solicitudes, ya que esta información se pasa al cliente.  ¿Desea continuar?',
        label: {
            name: 'Nombre',
            reviewRequest: 'Solicitar revisión',
            driverName: 'Nombre del conductor',
            driverEmail: 'Correo electrónico del conductor',
            requestedDate: 'Fecha de solicitud',
            action: 'Acción',
            amount: 'Cantidad',
            refundRequested: 'Retirada solicitada',
            status: 'Estado',
            accountNumber: 'Número de cuenta',
            sortCode: 'Código de sucursal',
            enterComments: 'Introducir comentarios',
            pending: 'Pendiente',
            closed: 'Cerrado',
            complete: 'Completo',
            decline: 'Rechazar',
            review_by: 'Reseñado por',
            review_date: 'Reseñado el',
            approvalRequest: 'Aprobar solicitud',
            processRefundRequest: 'Procesar solicitud de retirada',
            completeRefundRequest: 'Completar solicitud de retirada',
            bulkCompleteRefundRequest: 'Completar solicitudes de retirada',
            declineRefundRequest: 'Rechazar solicitud de retirada',
            bulkdeclineRefundRequest: 'Rechazar solicitudes de retirada',
            export: 'Exportar datos',
            bulk: 'Bloque',
        },
        button: {
            decline: 'Rechazar',
            approve: 'Aprobar',
            reset: 'Restablecer',
            search: 'Buscar',
            complete: 'Completo',
            save: 'Guardar',
            cancel: 'Cancelar',
            yes: 'Sí',
            no: 'No',
        },
        placeholder: {
            selectStatus: 'Seleccionar estado',
            enterComments: 'Introducir comentarios',
            name: 'Nombre/correo electrónico',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Complete/rechace esta solicitud.',
            },
            selectWithdrawalApprovals: 'Seleccione las solicitudes de retirada',
        },
    },
    termsAndConditionListing: {
        title: 'Términos y condiciones - ##COMPANY_BRAND_NAME## : Carga rápida de VE Reino Unido',
        header: 'Términos y condiciones',
        noteDetails: '*Es obligatorio aceptarlo para usar/crear una cuenta.',
        label: {
            iAggreeToTermsCondition: 'Acepto',
            note: 'Nota:',
            termsAndConditions: 'Términos y condiciones.',
            reviewUpdatedCondition:
                'Revise y acepte los términos y condiciones actualizados que se proporcionan a continuación.',
            name: 'Nombre',
            accepted: 'Aceptado',
        },
        button: {
            accept: 'Aceptar',
            next: 'Siguiente',
            cancel: 'Cancelar',
        },
        errors: {
            acceptTermCondition: 'Acepte los Términos y condiciones *obligatorios para continuar.',
        },
    },
    adminDashboard: {
        title: 'Inicio: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Panel de control',
        formtitle: 'Validación de formulario',
        label: {
            filter: 'Filtro',
            reportTags: 'Etiquetas de informe',
            driverGroup: 'Grupos de conductor',
            selectDriverGroup: 'Seleccionar grupos de conductor',
            selectTags: 'Seleccionar etiquetas',
            dateRange: 'Rango de fechas',
            month: 'Mes',
            year: 'Año',
            day: 'Día',
            week: 'Semana',
            userSessionTitle: 'Sesiones del conductor',
            userSessions: 'Sesiones del conductor',
            totalIncomeTitle: 'Suma de ingresos',
            income: 'Ingresos',
            transactionTitle: 'Promedio de transacción',
            transaction: 'Transacción',
            energy: 'Energía',
            energyTitle: 'Total de energía (kWh)',
            failedPaymentTitle: 'Cantidad de pagos fallidos',
            failedPayment: 'Pago fallido',
            driverCountTitle: 'Número de conductores',
            driver: 'Conductor',
            accumulatedVolts: 'Volts acumulados',
            claimedVolts: 'Volts reclamados',
            outStandingFailPayment: 'Pago fallido pendiente',
            outStandingFailedPaymentTitle: 'Pagos fallidos pendientes',
            voltsLiability: 'Responsabilidad de Volts',
            voltsAccumulatedTitle: 'Volts acumulados',
            volts: 'Volts',
            voltsClaimedTitle: 'Volts reclamados',
            lapsedVolts: 'Volts caducados',
            totalNoOfDriverAccount: 'Número total de cuentas de conductor',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            badDebtor: 'Moroso/a',
            cancelled: 'Cancelado',
            deleted: 'Eliminado',
            fake_account: 'Cuenta falsa',
            numberOfReferees: 'Número de personas recomendadas',
            numberOfReferrers: 'Número de personas que recomiendan',
            referralPayment: 'Pagos de recomendación (Persona que recomienda + Persona recomendada)',
            referrer: 'Persona que recomienda',
            referee: 'Persona recomendada',
            moneySpent: 'Dinero gastado solo por personas recomendadas',
            referralBonus: 'bono de recomendación',
            referralPromotion: 'Promoción de recomendaciones',
            overnightAutomated: 'Día siguiente automatizado',
            customerManual: 'Manual cliente',
            pending: 'Pendiente',
            patnerPromoClicksCount: 'Recuento de clics de promociones de socios',
            clicksCount: 'Recuento de clics',
            clicksCountMessage:
                'Seleccione una o varias opciones para mostrar el recuento de clics de promociones de socios',
            individualDrivers: 'Cuentas de conductor habilitadas',
            organisationDrivers: 'Cuentas de organizaciones habilitadas',
            individualAndOrgDriverCount: 'Cuentas habilitadas: Conductores vs organizaciones',
            alerts: 'Alertas',
            alertsCountTitle: 'Recuento de alertas',
            premiumSubscriptions: 'Suscripciones premium',
            activeSubscriptions: 'Suscripciones premium activas en total',
            newSubscriptions: 'Nuevas suscripciones',
            cancelledSubscriptions: 'Suscripciones canceladas',
            subscriptions: '(Suscripciones)',
        },
        placeholder: {
            patnerPromotions: 'Seleccione una o mas promociones de socios para mostrar los datos',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Borrar',
            syncData: 'Sincronizar datos',
        },
    },
    footer: {
        version: 'Versión',
        copyRightText: 'Todos los derechos reservados',
    },
    cardReader: {
        title: 'Lectores de tarjeta: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Lectores de tarjeta',
        manageCardReader: 'Administrar lector de tarjeta',
        importHeader: 'Importar lectores de tarjeta',
        button: {
            import: 'Importar',
            add: 'Añadir',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            action: 'Acción',
            delete: 'Eliminar',
            search: 'Buscar',
            reset: 'Restablecer',
            disable: 'Deshabilitar',
            duplicate: 'Duplicado',
            active: 'Activo',
            chargeStation: 'Estaciones de carga',
            yes: 'Sí',
            no: 'No',
            claimCardReader: 'Reclamar lectores de tarjetas no asignados',
            claim: 'Afirmar',
        },
        label: {
            description: 'Descripción',
            latitude: 'Latitud',
            longitude: 'Longitud',
            serialNumber: 'Número de serie',
            endPoint: 'Terminal',
            createdDate: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            csvFile: 'Archivo CSV',
            clickHere: 'Haga clic aquí',
            downloadTemplate: 'para descargar el modelo',
            evse_id: 'EVSE ID',
            error: 'Error',
            errorDetail: 'Error de detalles',
            failureReason: 'Razón del fracaso',
            id: 'ID del lector de tarjetas',
        },
        placeholder: {
            description: 'Descripción',
            latitude: 'Latitud',
            longitude: 'Longitud',
            serialNumber: 'Número de serie',
            endPoint: 'Reemplazar terminal',
            selectStatus: 'Seleccionar estado',
        },
        errors: {
            latitude: {
                min: 'La latitud debe estar entre -90,0 y 90,0',
                max: 'La latitud debe estar entre -90,0 y 90,0',
                number: 'La latitud debe ser un número',
            },
            longitude: {
                min: 'La longitud debe estar entre -180,0 y 180,0',
                max: 'La longitud debe estar entre -180,0 y 180,0',
                number: 'La longitud debe ser un número',
            },
            serial_number: {
                valid: 'Introduzca un número de serie válido',
            },
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            duplicateConfirmMesage: '¿Está seguro/a de que desea duplicarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            activeConfirmMesage: '¿Está seguro/a de que desea activarlo?',
        },
        assign: {
            header: 'Estaciones de carga',
            headerModal: 'Estación de carga',
            placeholder: {
                name: 'Introduzca el nombre',
                address: 'Dirección',
                tags: 'Seleccionar etiquetas',
            },
            label: {
                add: 'Añadir',
                address: 'Dirección',
                city: 'Ciudad',
                name: 'Nombre',
                type: 'Tipo',
                physical_reference: 'Referencia física',
                postcode: 'Código postal',
                action: 'Acción',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            },
        },
    },
    cardScheme: {
        title: 'Programas de tarjetas: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Programas de tarjetas',
        manageCardScheme: 'Administrar programa de tarjeta',
        label: {
            TransIdSeed: 'Valor original de ID de transacción',
            keybEncrKey: 'Clave de cifrado KeyB',
            transIdEncrKey: 'Clave de cifrado de ID de transacción',
            emspCode: 'Código EMSP',
            endPoint: 'Terminal',
            createdDate: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
        },
        button: {
            import: 'Importar',
            add: 'Añadir',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            action: 'Acción',
            delete: 'Eliminar',
            search: 'Buscar',
            reset: 'Restablecer',
            disable: 'Deshabilitar',
            enable: 'Permitir',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
        },
        placeholder: {
            emspCode: 'Código de Proveedor de Servicios eMobility',
            keybEncrKey: 'Clave de cifrado KeyB',
            transIdEncrKey: 'Clave de cifrado de ID de transacción',
            TransIdSeed: 'Valor original de ID de transacción',
        },
        errors: {
            emsp_code: {
                valid: 'Introduzca un código EMSP válido',
            },
            transaction_id_seed: {
                valid: 'Introduzca un valor original de ID de transacción válido',
                min: 'El valor original de ID de transacción válido no puede ser inferior a 0',
                max: 'Límite máximo alcanzado para el valor original de ID de transacción',
            },
        },
    },
    fleetProfile: {
        orgProfile: 'Perfil de la organización',
        message: {
            success: 'Perfil de la organización actualizado satisfactoriamente',
        },
    },
    dataAggregator: {
        title: 'Agregadores de Datos: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Agregadores de Datos',
        button: {
            add: 'Añadir',
            search: 'Buscar',
            reset: 'Restablecer',
            enable: 'Permitir',
            disable: 'Deshabilitar',
            edit: 'Editar',
            yes: 'Sí',
            no: 'No',
            action: 'Acción',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            syncDataAggregatorAPIKeys: 'Sincroniza las claves API con los planes de uso',
        },
        placeholder: {
            name: 'Nombre',
            status: 'Seleccionar estado',
        },
        label: {
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            name: 'Nombre',
            party_id: 'ID de la parte',
            country_code: 'Código de país',
            version_url: 'URL de la versión',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
        },
        message: {
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
        },
        insert: {
            header: 'Gestionar agregador de datos',
            errors: {
                common: 'Algo ha fallado, vuelva a intentarlo.',
                name: {
                    valid: 'Introduzca un nombre de agregador de datos válido',
                },
                party_id: {
                    valid: 'Introduzca un ID de parte válido',
                },
                country_code: {
                    valid: 'Introduzca un código de país válido',
                },
                version_url: {
                    url: 'La URL de la versión debe ser una URL válida',
                },
                token: {
                    valid: 'Introduzca un token válido',
                },
            },
            placeholder: {
                name: 'Nombre',
                party_id: 'ID de la parte',
                country_code: 'Código de país',
                version_url: 'URL de la versión del agregador de datos',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                emsp: 'Proveedor de Servicios eMobility',
                access_group: 'Grupo de acceso',
                usagePlan: 'Plan de uso',
            },
            label: {
                name: 'Nombre',
                party_id: 'ID de la parte',
                country_code: 'Código de país',
                version_url: 'URL de la versión',
                emsp: 'Proveedor de Servicios eMobility',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                allow_locations_to_be_extracted: 'Solo se permite extraer ubicaciones del EMPS',
                allow_receive_location_update:
                    'Permitir la recepción de actualizaciones de ubicación PUT (en arranque inicial) y PATCH (actualización del estado)',
                access_group: 'Grupo de acceso',
                allow_tariff_extraction: 'Incluir Tarifa',
                usagePlan: 'Plan de uso',
            },
        },
    },
    accessGroups: {
        title: 'Grupos de acceso: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Acceder a grupos',
        manageAccessGroup: 'Administrar grupo de acceso',
        label: {
            createdDate: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            name: 'Nombre',
            description: 'Descripción',
            access_control_type: 'Tipo de control de acceso',
            allow_public_access: 'Permitir acceso público',
            managed_by_organisation: 'Administrado por la organización',
            override_tariff: 'Reemplazar tarifa',
            yes: 'Sí',
            no: 'No',
            access_code: 'Código de acceso',
            deleted: '(Eliminado)',
        },
        button: {
            enable: 'Permitir',
            disable: 'Deshabilitar',
            action: 'Acción',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            add: 'Añadir',
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            deleted: '(Eliminado)',
            chargeStation: 'Ubicaciones de carga',
            yes: 'Sí',
            no: 'No',
            drivers: 'Conductores',
        },
        placeholder: {
            name: 'Nombre',
            selectStatus: 'Seleccionar estado',
            allow_public_access: 'Permitir acceso público',
            description: 'Descripción',
            access_control_type: 'Tipo de control de acceso',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
        },
        assign: {
            header: 'Ubicaciones de carga',
            headerModal: 'Ubicaciones de carga',
            placeholder: {
                name: 'Introduzca el nombre',
                address: 'Dirección',
                tags: 'Seleccionar etiquetas',
                postal_code: 'Código postal',
                power_type: 'Seleccionar tipo de potencia',
            },
            label: {
                add: 'Añadir',
                address: 'Dirección',
                city: 'Ciudad',
                name: 'Nombre',
                type: 'Tipo',
                physical_reference: 'Referencia física',
                postcode: 'Código postal',
                action: 'Acción',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            },
        },
        driverAssign: {
            header: 'Conductores',
            headerModal: 'Conductores',
            placeholder: {
                email: 'Correo electrónico',
                status: 'Estado',
            },
        },
        errors: {
            name: {
                valid: 'Introduzca un nombre válido',
            },
        },
    },
    accessGroupRequests: {
        title: 'Acceder a solicitudes de grupo: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Acceder a solicitudes de grupo',
        columns: {
            name: 'Nombre',
            email: 'Correo electrónico',
            federated_account_type: 'Tipo de cuenta federada',
            requested_access_group: 'Grupo de acceso solicitado',
            requested_date: 'Fecha de solicitud',
            driver_status: 'Estado de conductor',
            request_status: 'Estado de la solicitud',
            action: 'Acción',
        },
        button: {
            action: 'Acción',
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Guardar',
            cancel: 'Cancelar',
        },
        label: {
            review_request: 'Solicitar revisión',
            requested_access_group: 'Grupo de acceso solicitado:',
            approve: 'Aprobar',
            decline: 'Rechazar',
            enterComments: 'Comentarios',
        },
        placeholder: {
            nameEmail: 'Nombre/correo electrónico',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
            status: 'Seleccionar estado',
            enterComments: 'Introduzca sus comentarios',
        },
        errors: {
            approveReject: 'Apruebe/rechace esta solicitud.',
        },
    },
    payByWeb: {
        title: 'Pago por web: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Pago por web',
        columns: {
            evse_id: 'ID de EVSE',
            status: 'Estado',
            physical_reference: 'Referencia física',
            location_name: 'Nombre de la ubicación',
            location_address: 'Dirección de la ubicación',
            location_city: 'Ciudad de la ubicación',
            location_postal_code: 'Código postal de la ubicación',
            pay_by_web_active: 'Pago por web',
            action: 'Acción',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            enablePayByWeb: 'Habilitar Pago por web',
            disabledPayByWeb: 'Deshabilitar Pago por web',
            submit: 'Enviar',
            cancel: 'Cancelar',
        },
        label: {
            enabled: 'Permitir',
            disabled: 'Deshabilitar',
            manageUniqueCode: 'Administrar código único',
            uniqueCode: 'Código único',
        },
        message: {
            enableConfirmMesage:
                '¿Está seguro/a de que desea habilitar el pago por web en las estaciones seleccionadas?',
            disableConfirmMesage:
                '¿Está seguro/a de que desea deshabilitar el pago por web en las estaciones seleccionadas?',
        },
        placeholder: {
            evse_id: 'ID de EVSE',
            status: 'Seleccionar estado',
            physical_reference: 'Referencia física',
            location_name: 'Nombre de la ubicación',
            location_address: 'Dirección de la ubicación',
        },
        errors: {
            unique_code: {
                valid: 'Introduzca un código único válido',
            },
        },
    },
    driverDebt: {
        title: 'Deuda de conductor: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Deuda de conductor',
        button: {
            generate1Letters: 'Generar Carta 1',
            generate2Letters: 'Generar Carta 2',
            download: 'Descargar',
            strikeOneLetter: 'Carta de primer aviso',
            strikeTwoLetter: 'Carta de segundo aviso',
            generateStrikeOneLetters: 'Generar cartas de primer aviso',
            generateStrikeTwoLetters: 'Generar cartas de segundo aviso',
            runHistory: 'Generar cartas de aviso - Generar historial',
            pastLetters: 'Cartas anteriores',
            regenerateLetters: 'Volver a generar cartas',
            refreshPastLetters: 'Actualizar cartas anteriores',
        },
        label: {
            pastLetters: 'Cartas anteriores',
            inProgress: '(procesando)',
            noDataFound: 'No se han encontrado datos.',
            dynamicFields: 'Campos dinámicos',
            clickToCopy: '(Hacer clic para copiar anotación)',
            driverName: 'Nombre del conductor',
            driverDebt: 'Deuda de conductor',
            debtAge: 'Antigüedad de la deuda',
            driverEmail: 'Correo electrónico del conductor',
            driverAddress: 'Dirección del conductor',
            date: 'Fecha',
            clickToCopyTooltip: 'Hacer clic para copiar',
            regenerate: 'Volver a generar',
            regenerateLetters: 'Volver a generar cartas',
            letterTemplate: 'Modelo de carta',
            cancel: 'Cancelar',
            reportGenerationInProgress: '(El informe se está generando)',
            copyDriverIds: 'Haga clic para copiar los ID de conductor',
        },
        columns: {
            run: 'N.º de recorrido',
            driverIDs: 'IDs de conductor aptos en este punto del recorrido',
            runTimestamp: 'Marca de tiempo del recorrido',
            strikeType: 'Tipo de aviso',
            initiatedByUser: 'Usuario que inició el recorrido',
            regenerate: 'Volver a generar',
            action: 'Acción',
            relatedRun: 'N.º de recorrido relacionado',
            date: 'Fecha',
            file: 'Archivo',
            templateUsed: 'Modelo usado',
            generatedBy: 'Generado por',
        },
        placeholder: {
            strikeOneLetter: 'Seleccionar carta de primer aviso',
            strikeTwoLetter: 'Seleccionar carta de segundo aviso',
        },
    },
    fleetAccessGroups: {
        title: 'Acceder a solicitudes de grupo: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
    },
    emailLogs: {
        title: 'Registros de correo electrónico: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Registros de correo electrónico',
        columns: {
            recipient: 'Destinatario',
            subject: 'Asunto',
            deliveryStatus: 'Estado de entrega',
            errorMessage: 'Mensaje de error',
            createdDate: 'Fecha de creación',
        },
        label: {
            viewError: 'Ver error',
        },
        placeholder: {
            recipient: 'Destinatario',
            subject: 'Asunto',
            deliveryStatus: 'Estado de entrega',
            errorMessage: 'Mensaje de error',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
        },
    },
    alerts: {
        title: 'Registros de error de OCPI: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Registros de error de OCPI',
        columns: {
            api: 'url',
            api_call_type: 'Tipo de llamada de API',
            api_request_type: 'Tipo de solicitud',
            response_code: 'Código de respuesta',
            error_message: 'Mensaje de error',
            alert_type: 'Tipo de alerta',
            created_date: 'Fecha de creación',
            request_body: 'Cuerpo de solicitud',
            response_body: 'Cuerpo de respuesta',
        },
        placeholder: {
            api: 'url',
            alert_type: 'Tipo de alerta',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
        },
        label: {
            viewDetails: 'Ver detalles',
            errorLogDetails: 'Detalles de registros de error de OCPI',
        },
    },
    SubscriptionSetting: {
        title: 'Suscripciones premium: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Suscripciones premium',
        manageSubscription: 'Administrar suscripción premium',
        label: {
            subscription_type: 'Tipo de suscripción',
            subscription_amount: 'Importe de suscripción',
            free_subscription_duration: 'Duración de la suscripción gratuita',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            maximum_routing_call: 'Direccionamiento de llamadas máximo (por mes)',
            additional_volts_per_kwh: 'Recompensa adicional de Volt(s)/kWh',
            name: 'Nombre',
            description: 'Descripción',
            subscriptionImage: 'Imagen de suscripción premium',
            exportSubscribersList: 'Exportar lista de suscriptores',
            downloadSubscribersList: 'Descargar lista de suscriptores',
        },
        placeholder: {
            subscription_amount: 'Importe de suscripción',
            free_subscription_duration: 'Duración de la suscripción gratuita (Días)',
            maximum_routing_call: 'Direccionamiento de llamadas máximo',
            name: 'Nombre',
            status: 'Seleccionar estado',
            subscriptionType: 'Seleccionar tipo de suscripción',
            subscriptionImage: 'Seleccionar Imagen de suscripción premium',
        },
        button: {
            action: 'Acción',
            disable: 'Deshabilitar',
            enable: 'Habilitar',
            edit: 'Editar',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            enableDisable: 'Habilitar/Deshabilitar suscripción',
            add: 'Añadir',
            search: 'Buscar',
            reset: 'Restablecer',
        },
        errors: {
            amount: {
                moreThan: 'La cantidad debe ser superior a 1',
                lessThan: 'La cantidad debe ser inferior a 100',
                number: 'La cantidad debe ser un número',
            },
            duration: {
                moreThan: 'La duración debe ser superior a 1',
                lessThan: 'La duración debe ser inferior a 180',
            },
            maxRoutingCall: {
                moreThan: 'El valor máximo de direccionamiento de llamadas debe ser superior a 1',
                lessThan: 'El valor máximo de direccionamiento de llamadas debe ser inferior a 1000',
            },
            additionalVolts: {
                lessThan: 'El valor debe ser menor o igual a 5',
                number: 'El valor debe ser un número',
            },
        },
        message: {
            enableFromConfig:
                'Para habilitar una suscripción premium, primero debe establecer la opción "Permitir suscripción premium" como "Verdadera" en Ajustes > Configuración',
            disableConfirmMessage:
                'Atención: Al cambiar la Suscripción premium se cancelarán todas las renovaciones automáticas de la cuenta del conductor asociadas. ¿Está seguro/a de que desea deshabilitarlo?',
            enableConfirmMessage: '¿Está seguro/a de que desea habilitarlo?',
        },
    },
    advertisingDevices: {
        title: 'Dispositivos publicitarios: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Dispositivos publicitarios',
        label: {
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            device_name: 'Nombre',
            device_id: 'ID de dispositivo',
            postal_code: 'Código postal',
            charge_station: 'Estación de carga',
            screen_size: 'Tamaño de pantalla',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            operational: 'Operativo',
        },
        button: {
            action: 'Acción',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            add: 'Añadir',
            reset: 'Restablecer',
            search: 'Buscar',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            assignVideos: 'Asignar vídeos',
            yes: 'Sí',
            no: 'No',
            regenerateS3File: 'Regenerar archivo S3',
            mediaTerminalLogs: 'Registros de terminal de medios',
        },
        placeholder: {
            device_name: 'Nombre del dispositivo',
            postal_code: 'Código postal',
            charge_station: 'Estación de carga',
            selectStatus: 'Seleccionar estado',
            screen_size: 'Tamaño de pantalla',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
        },
        insert: {
            header: 'Administrar dispositivo publicitario',
            placeholder: {
                device_name: 'Nombre del dispositivo',
                device_id: 'ID de dispositivo',
                charge_station: 'Estación de carga',
                screen_size: 'Tamaño de pantalla',
            },
            label: {
                device_name: 'Nombre del dispositivo',
                device_id: 'ID de dispositivo',
                charge_station: 'Estación de carga',
                screen_size: 'Tamaño de pantalla',
            },
            errors: {
                common: 'Algo ha fallado, vuelva a intentarlo.',
                name: {
                    valid: 'Introduzca un nombre válido',
                },
                device_id: {
                    valid: 'Introduzca un ID de dispositivo válido',
                    min: 'El ID de dispositivo debe tener al menos 6 caracteres',
                },
            },
        },
        assignVideos: {
            header: 'Vídeos',
            headerModal: 'Vídeos',
            label: {
                action: 'Acción',
                delete: 'Eliminar',
            },
            placeholder: {
                file_name: 'Nombre del archivo',
                description: 'Descripción',
            },
            message: {
                deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            },
        },
    },
    advertisingVideos: {
        title: 'Vídeos publicitarios: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Vídeos publicitarios',
        label: {
            file_name: 'Nombre del archivo',
            description: 'Descripción',
            operational_start_date: 'Fecha de inicio operativo',
            operational_end_date: 'Fecha de finalización operativa',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            reviewVideo: 'Revisar vídeo',
            approve: 'Aprobar',
            reject: 'Rechazar',
            videoUpload: 'Vídeo',
            comments: 'Comentarios',
        },
        button: {
            action: 'Acción',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            add: 'Añadir',
            reset: 'Restablecer',
            search: 'Buscar',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
            reviewVideo: 'Revisar vídeo',
            downloadVideo: 'Descargar vídeo',
            assignDevice: 'Asignar dispositivos',
        },
        placeholder: {
            file_name: 'Nombre del archivo',
            description: 'Descripción',
            start_date: 'Fecha de inicio operativo',
            end_date: 'Fecha de finalización operativa',
            selectStatus: 'Seleccionar estado',
            videoUpload: 'Vídeo',
            enterComments: 'Introduzca sus comentarios',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
        },
        insert: {
            header: 'Administrar vídeo publicitario',
            placeholder: {
                description: 'Descripción',
                operational_start_date: 'Fecha de inicio operativo',
                operational_end_date: 'Fecha de finalización operativa',
            },
            label: {
                description: 'Descripción',
                operational_start_date: 'Fecha de inicio operativo',
                operational_end_date: 'Fecha de finalización operativa',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Apruebe/rechace esta solicitud.',
                },
            },
            name: {
                valid: 'Introduzca un nombre válido',
            },
            file_name: {
                fileType:
                    'Se pueden subir archivos con las extensiones ".mp4", ".flv", ".wmv", ".mpeg", ".avi", ".3gp"',
                uploadError: 'Error al subir el archivo de vídeo',
                required: 'Es necesario un archivo de vídeo',
                fileNameLength: 'Se permite un máximo de 15 caracteres en el nombre del archivo',
            },
            file_size: 'El límite máximo del tamaño de carga es',
        },
        assignDevices: {
            header: 'Dispositivos',
            headerModal: 'Dispositivos',
            label: {
                action: 'Acción',
                delete: 'Eliminar',
            },
            placeholder: {
                device_name: 'Nombre del dispositivo',
                device_id: 'ID de dispositivo',
                status: 'Estado',
            },
            message: {
                deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Credenciales publicitarias: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Credenciales publicitarias',
        manageCredentials: 'Administrar credenciales publicitarias',
        label: {
            bucket_name: 'Nombre de bucket',
            region_name: 'Nombre de la región',
            download_access_key: 'Descargar clave de acceso',
            download_secret_key: 'Descargar clave secreta',
            upload_access_key: 'Subir clave de acceso',
            upload_secret_key: 'Subir clave secreta',
            download_info_object_name: 'Descargar nombre de objeto de información',
            upload_path: 'Ruta de carga',
            dialog_password: 'Contraseña de diálogo',
            expect_bucket_name: 'Esperando nombre de bucket',
            expect_region_name: 'Esperando nombre de la región',
            expect_download_access_key: 'Esperando descarga de clave de acceso',
            expect_download_secret_key: 'Esperando descarga de clave secreta',
            version_code: 'Código de la versión',
            download_url: 'URL de descarga',
            prompt: 'Indicador',
            remarks: 'Observaciones',
            modified_by: 'Modificado por',
            modified_date: 'Fecha de modificación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
        },
        button: {
            action: 'Acción',
            disable: 'Deshabilitar',
            enable: 'Habilitar',
            edit: 'Editar',
            back: 'Atrás',
            save: 'Guardar',
            cancel: 'Cancelar',
        },
    },
    organisationInvoices: {
        title: 'Facturas de la organización: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Facturas de la organización',
        label: {
            name: 'Organización',
            invoice_id: 'ID de factura',
            invoice_value: 'Valor de factura',
            invoice_date: 'Fecha de factura',
            action: 'Acción',
            undo: 'Anular',
            undoPayment: 'Anular pago',
            disputed: 'En disputa',
            adjustAmount: 'Ajustar valor de factura',
            paid_value: 'Valor pagado',
            outstanding: 'Pendiente de pago',
            status: 'Estado',
            comments: 'Comentarios',
            original_value: 'Valor original',
        },
        placeholder: {
            name: 'Nombre',
            start_date: 'Fecha de inicio',
            end_date: 'Fecha de finalización',
            status: 'Estado',
            organisation: 'Seleccionar organización',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            pay: 'Pagar',
            partPay: 'Pagar una parte',
            undo: 'Anular',
            disputed: 'En disputa',
            adjustValue: 'Ajustar valor de factura',
        },
        errors: {
            amount: {
                moreThan: 'La cantidad debe ser superior a 0',
                maxValue: 'Valor máximo de cantidad alcanzado',
                notZero: 'La cantidad debe ser superior/inferior a 0',
                minValue: 'Valor mínimo de cantidad alcanzado',
                number: 'La cantidad debe ser un número',
            },
            organisation: {
                required: 'Seleccione una organización',
            },
        },
        message: {
            undoConfirmMessage:
                '¿Está seguro/a de que desea eliminar el valor pagado y cambiar el estado a "Pendiente" en esta factura?',
            disputedConfirmMessage: '¿Está seguro/a de que desea cambiar el estado a "En disputa" en esta factura?',
        },
        payModal: {
            header: 'Pagar',
            partPayHeader: 'Pagar una parte',
            label: {
                amount: 'Cantidad',
                date_paid: 'Fecha de pago',
                comments: 'Comentarios',
            },
            placeholder: {
                amount: 'Introducir cantidad',
                date_paid: 'Introducir fecha de pago',
                comments: 'Introducir comentarios',
            },
            button: {
                accept: 'Aceptar',
                send_for_approval: 'Enviar para aprobación',
                cancel: 'Cancelar',
                submit: 'Enviar',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Registros de terminal de medios: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Registros de terminal de medios',
        label: {
            file_name: 'Nombre del archivo',
            date_played: 'Fecha de reproducción',
            play_time: 'Tiempo de reproducción',
            start_time: 'Hora de inicio',
        },
        placeholder: {
            fileName: 'Nombre del archivo',
            startDate: 'Fecha de inicio',
            endDate: 'Fecha de finalización',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Historial de límite de gasto: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Historial de límite de gasto',
        label: {
            enabled: 'Permitido',
            disabled: 'Deshabilitado',
            name: 'Nombre del conductor',
            email: 'Correo electrónico del conductor',
            type: 'Tipo de umbral',
            spend_limit_exceed_date: 'Fecha de límite de gasto excedida',
            status: 'Estado de conductor',
            action: 'Acción',
            export: 'Exportar',
            onStop: 'En parada',
            cancelOnStop: 'Cancelar en parada',
        },
        button: {
            disable: 'Deshabilitar',
            enable: 'Habilitar',
            search: 'Buscar',
            reset: 'Restablecer',
            yes: 'Sí',
            no: 'No',
            back: 'Atrás',
        },
        placeholder: {
            name: 'Nombre del conductor',
            email: 'Correo electrónico del conductor',
            status: 'Selecionar estado de conductor',
            dateFrom: 'Fecha de límite excedida desde',
            dateTo: 'Fecha de límite excedida hasta',
            type: 'Seleccionar tipo de umbral',
        },
        message: {
            noDataToExport: 'No hay datos que exportar.',
            cancelOnStopConfirmation: '¿Está seguro/a de que desea cancelar en parada para este conductor?',
        },
    },
    driverDebtorLetters: {
        title: 'Cartas de deudor de conductor: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Cartas de deudor de conductor',
        manageDriverDebtorLetter: 'Administrar carta de deudor de conductor',
        label: {
            reportType: 'Tipo de informe',
            defaultLetter: 'Modelo de carta de deudor en mora',
            content: 'Contenido',
            enabled: 'Habilitado',
            disabled: 'Deshabilitado',
            created_date: 'Fecha de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            dynamicFields: 'Campos dinámicos',
            copyNotation: '(Hacer clic para copiar anotación)',
            clickToCopy: 'Hacer clic para copiar',
            driverName: 'â€¢ Nombre del conductor',
            driverDebt: 'â€¢ Deuda de conductor',
            debtAge: 'â€¢ Antigüedad de la deuda',
            driverEmail: 'â€¢ Correo electrónico del conductor',
            driverAddress: 'â€¢ Dirección del conductor',
            date: 'â€¢ Fecha',
            uniqueReference: 'â€¢ Referencia única',
            useStandardTemplate: 'Usar modelo estándar',
        },
        column: {
            defaultLetter: 'Carta predeterminada',
        },
        button: {
            setDefaultLetter: 'Establecer por defecto',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            edit: 'Editar',
            delete: 'Eliminar',
            createDuplicate: 'Crear duplicado',
            save: 'Guardar',
            cancel: 'Cancelar',
            preview: 'Vista previa',
        },
        message: {
            setDefaultConfirmMesage: '¿Está seguro/a de que desea establecer esta carta de deudor como predeterminada?',
            enableConfirmMesage: '¿Está seguro/a de que desea habilitarlo?',
            disableConfirmMesage: '¿Está seguro/a de que desea deshabilitarlo?',
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
        },
        error: {
            emptyContent: 'Proporcione el contenido para obtener una vista previa del modelo de carta',
            common: 'Se ha producido un error al procesar su solicitud, vuelva a intentarlo más tarde.',
            supportedDynamicField1: 'Estos campos dinámicos',
            supportedDynamicField2: 'solo se admiten para cartas de deudor.',
        },
    },
    driverSubscriptions: {
        title: 'Suscripciones premium del conductor: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        header: 'Suscripciones premium',
        label: {
            subscriptionType: 'Tipo de suscripción',
            subscriptionStartDate: 'Fecha de inicio de suscripción',
            subscriptionStatus: 'Estado de la suscripción',
            renewalOrExpiryDate: 'Fecha de renovación/caducidad',
            voltsCredited: 'Volts incluidos',
            journeysPlanned: 'Viajes planificados',
            active: 'Activo',
            cancelled: 'Cancelado',
            action: 'Acción',
            cancel: 'Cancelar',
            cancelSubscription: 'Cancelar suscripción',
            terminate: 'Finalizar',
            terminateSubscription: 'Finalizar suscripción',
            freeTrial: 'Prueba gratuita',
            name: 'Nombre',
            promotion: 'Promoción',
        },
        message: {
            cancelConfirmMessage:
                '¿Está seguro/a de que desea cancelar la suscripción para este usuario? Esto cancelará la siguiente renovación automática de la suscripción.',
            terminateConfirmMessage:
                '¿Está seguro/a de que desea finalizar la suscripción para este usuario? Esto cancelará la siguiente renovación automática de la suscripción y suspenderá todos los beneficios de esta suscripción de inmediato.',
            terminateConfirmMessageWithoutRenew:
                '¿Está seguro/a de que desea finalizar la suscripción para este usuario? Esto suspenderá todos los beneficios de esta suscripción de inmediato.',
        },
    },
    advertisingDropDownDefaultmessage:
        'Introduzca al menos 3 caracteres de la ubicación para mostrar la lista de estaciones',
    rfidcardDropDownDefaultMessage: 'Introduzca al menos 3 caracteres para mostrar la lista de conductores/vehículos',
    chargeStationMapDropDownDefaultMessage:
        'Introduzca al menos 3 caracteres de la estación de carga para mostrar las estaciones de carga',
    startChargePageDropDownDefaultMessage:
        'Introduzca los caracteres de las ubicaciones para mostrar la lista de ubicaciones',
    groupGridDropDownDefaultMessage: 'Introduzca al menos 3 caracteres para mostrar la lista de conductores/vehículos',
    organisationdashBoardDefaultMessage:
        'Introduzca al menos 3 caracteres para mostrar la lista de conductores/vehículos',
    rfidAssigncardDefaultDropDownMessage:
        'Introduzca al menos 3 caracteres del correo electrónico del conductor para mostrar la lista de conductores',
    continueTypingSearch: 'Siga escribiendo para rectificar la búsqueda',
    limitExceedAddressError: 'No hemos podido encontrar la dirección en este momento',
    noFileChosen: 'No se ha elegido ningún archivo',
    ChooseFile: 'Elegir archivo',
    noOptions: 'Sin opciones',
    requiredField: 'El archivo es un campo necesario',
    removeImage: 'Eliminar imagen',
    help: 'Ayuda',
    editor: {
        bold: 'Negrita',
        italic: 'Cursiva',
        underline: 'Subrayar',
        strikeThrough: 'Tachar',
        monospace: 'Monoespaciado',
        superscript: 'Superíndice',
        subscript: 'Subíndice',
        blockType: 'Tipo de bloque',
        fontSize: 'Tamaño de fuente',
        font: 'Fuente',
        unordered: 'Sin ordenar',
        ordered: 'Ordenado',
        indent: 'Añadir sangría',
        outdent: 'Anular sangría',
        left: 'Izquierda',
        right: 'Derecha',
        center: 'Centro',
        justify: 'Justificar',
        colorPicker: 'Selector de color',
        link: 'Enlace',
        unlink: 'Eliminar enlace',
        embedded: 'Incrustar',
        emoji: 'Emoji',
        remove: 'Eliminar',
        undo: 'Deshacer',
        redo: 'Rehacer',
        image: 'Imagen',
    },
    map: {
        zoomIn: 'Acercar',
        zoomOut: 'Alejar',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    noDataFound: '¡Lo sentimos! No se han encontrado datos',
    globalService: {
        title: 'Registro de servicios globales: Plataforma de servicios eMobility de ##COMPANY_BRAND_NAME##',
        status: {
            pending:
                'Para comunicarse con servicios globales, introduzca la información a continuación, pulsando el botón "Registrarse" puede configurar la comunicación.',
            registered:
                'La plataforma EMSP puede comunicarse ahora mismo con servicios globales. Si tiene algún problema para establecer la comunicación, introduzca la información a continuación y haga clic en el botón "Volver a registrarse".',
        },
        insert: {
            url: 'URL',
            handshakeToken: 'Token saludo',
        },
        placeholder: {
            url: 'URL',
            handshakeToken: 'Token saludo',
        },
        label: {
            note: 'Nota',
            noteValue:
                'Es necesario introducir el "Token saludo" cada vez que se ha establecido la comunicación con servicios globales. Para identificar el "Token saludo", póngase en contacto con el administrador del sistema.',
            rfidSync: 'Sincronización con RFID',
        },
        button: {
            register: 'Registrarse',
            reRegister: 'Volver a registrarse',
        },
        error: {
            errorWhileCreatingGlobalService: 'Se ha producido un error al crear el servicio global.',
            errorWhileUpdatingGlobalService: 'Se ha producido un error al actualizar el servicio global.',
        },
        endpointsTable: {
            header: 'Terminal de servicios globales',
            column: {
                identifer: 'Identificador',
                httpMethod: 'Método Http',
                url: 'Url',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Desglose detallado',
        total_cost: 'Coste total',
        conversion_rate: 'Tasa de conversión',
    },
    SubscriptionImages: {
        title: 'Imágenes de suscripción premium',
        manageSubscriptionImage: 'Administrar Imagen de suscripción premium',
        label: {
            name: 'Nombre',
            description: 'Descripción',
            action: 'Acción',
            delete: 'Eliminar',
            image: 'Imagen',
            language: 'Idioma',
        },
        button: {
            edit: 'Editar',
            search: 'Buscar',
            reset: 'Restablecer',
            add: 'Añadir',
        },
        message: {
            deleteConfirmMesage: '¿Está seguro/a de que desea eliminarlo?',
        },
        errors: {
            insertEnglishLanguageImage: 'Cargue la imagen del idioma inglés',
            required: 'La imagen es necesaria.',
        },
    },
    driverPaymentCards: {
        title: 'Tarjetas de pago de conductor: Plataforma de servicios eMobility de InstaVolt',
        header: 'Tarjetas de pago',
        label: {},
    },
};
